import React, {
  Fragment,
  useEffect,
  useRef,
  useMemo,
  useState,
  useCallback,
  use,
} from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import Slide from "@mui/material/Slide";
import {
  Box,
  FormControlLabel,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Select,
  Switch,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Tooltip,
} from "@mui/material";

import { IoMdClose } from "react-icons/io";

import PropTypes from "prop-types";

import parse from "html-react-parser";
import axios, { all } from "axios";
import axiosInstance from "../CommonGlobals/axiosInstance.js";
import { orderBy, set } from "lodash";
import {
  MdArrowBack,
  MdArrowForward,
  MdClose,
  MdFemale,
  MdMale,
  MdInfo,
} from "react-icons/md";

import { BiMale } from "react-icons/bi";
import { FaFemale } from "react-icons/fa";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import {
  useForm,
  Controller,
  useFieldArray,
  FormProvider,
} from "react-hook-form";

import { usePath } from "../CommonGlobals/PathContext";

import { GiSteeringWheel } from "react-icons/gi";
import { MdOutlineScreenRotationAlt } from "react-icons/md";

import SeatLayoutHorizontalSkeleton from "../CommonGlobals/SeatLayoutHorizontalSkeleton";
import { CiLocationArrow1, CiLocationOn, CiPhone } from "react-icons/ci";
import { TbView360, TbView360Number } from "react-icons/tb";
import { HiClipboardCopy } from "react-icons/hi";
import { FaRegCopy } from "react-icons/fa6";

import { useAppGlobalState } from "../CommonGlobals/Store";
import ComponentLevelLoader from "../CommonGlobals/ComponentLevelLoader.jsx";

import PlatformDetector from "../CommonGlobals/PlatformDetector";
import { MISBookingMode } from "../CommonGlobals/TRMISBookingMode";

import { getPgSelectorUrlString } from "../CommonGlobals/PGSelector.js";

import { sendEventTobackend } from "../CommonGlobals/sendEventDataTobackend";
import ContactPhone from "./ContactPhone.jsx";

const customTheme = createTheme({
  palette: {
    theme: {
      primary: "#1F1F1F", // Blue color
      secondary: "#3D18B5", // Blue color
      button: "#F4CC08", // Blue color
    },
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CustomTabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      hidden={value !== index}
      {...other}
      style={{ padding: 0 }}
    >
      <Box sx={{ p: 1, display: value === index ? "block" : "none" }}>
        {children}
      </Box>
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function CustomJourneyOnwardTabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      hidden={value !== index}
      {...other}
      style={{ padding: 0 }}
    >
      <Box sx={{ p: 1, display: value === index ? "block" : "none" }}>
        {children}
      </Box>
    </div>
  );
}

CustomJourneyOnwardTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function CustomJourneyReturnTabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      hidden={value !== index}
      {...other}
      style={{ padding: 0 }}
    >
      <Box sx={{ p: 1, display: value === index ? "block" : "none" }}>
        {children}
      </Box>
    </div>
  );
}

CustomJourneyReturnTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const JourneyRoundTripDailog = ({
  dailogOnwardInputData = {
    journeyDataUrl: "/seatArrangementdirectdata.json",
  },
  dailogReturnInputData = {
    journeyDataUrl: "/seatArrangementdirectdata.json",
  },
  open = false,
  currentTab = 0,
  currerntMainTab = 0,
  dialogClose,
  paymentUrl = "/payments",
  handleTabChangeInDialog,
  clickedFrom,
}) => {
  const [globalData, setGlobalData] = useAppGlobalState();

  // common state variables for onward and return journey

  //const [dailogOpen, setDailogOpen] = useState(open);
  const [tabMainValue, setTabMainValue] = useState(currerntMainTab);
  const [tabValue, setTabValue] = useState(currentTab);
  const [returnTabValue, setReturnTabValue] = useState(0);

  const [subtotalOnward, setSubTotalOnward] = useState(0);
  const [gstInpercentOnward, setGstInpercentOnward] = useState(null);
  const [totalGstOnward, setTotalGstOnward] = useState(0);
  const [discountOnward, setDiscountOnward] = useState(0);

  const [subtotalReturn, setSubTotalReturn] = useState(0);
  const [gstInpercentReturn, setGstInpercentReturn] = useState(null);
  const [totalGstReturn, setTotalGstReturn] = useState(0);
  const [discountReturn, setDiscountReturn] = useState(0);

  const [discountInPercentOnward, setDiscountInPercentOnward] = useState(0);
  const [discountInPercentReturn, setDiscountInPercentReturn] = useState(0);

  const [grandTotalOnward, setGrandTotalOnward] = useState(0);
  const [grandTotalReturn, setGrandTotalReturn] = useState(0);
  const [grandwithoutDiscOnward, setGrandwithoutDiscOnward] = useState(0);
  const [grandwithoutDiscReturn, setGrandwithoutDiscReturn] = useState(0);

  const { paths } = usePath();

  const [isLoading, setIsLoading] = useState(false);

  const [deviceType, setDeviceType] = useState(0);

  const [MISBookingModeState, setMISBookingModeState] = useState(0);
  const [pgselectorUrl, setPgselectorUrl] = useState("");

  const [isTermsAndConditionsChecked, setIsTermsAndConditionsChecked] =
    useState();

  const [journeyOnwardObject, setJourneyOnwardObject] = useState(null);
  const [journeyReturnObject, setJourneyReturnObject] = useState(null);

  const [contactDetailsOnward, setContactDetailsOnward] = useState({
    mobileOnward: "",
    emailOnward: "",
  });

  const [contactDetailsReturn, setContactDetailsReturn] = useState({
    mobileReturn:"",
    emailReturn: "",
  });

  // onward Journey State VAraibles

  const [layoutdata, setLayoutData] = useState(null);

  const [layoutsList, setLayoutsList] = useState(null);

  const [layoutsArrayData, setLayoutsArrayData] = useState(null);

  const [parsedData, setParsedData] = useState(null);

  const [isLayoutDataLoading, setIsLayoutDataLoading] = useState(false);

  const [pickupPoints, setPickupPoints] = useState(null);
  const [droppingPoints, setDroppingPoints] = useState(null);

  const [selectedBoarding, setSelectedBoarding] = useState(null);
  const [selectedDropping, setSelectedDropping] = useState(null);

  const [selectedBoardingName, setSelectedBoardingName] = useState(null);
  const [selectedDroppingName, setSelectedDroppingName] = useState(null);

  const [selectedSeats, setSelectedSeats] = useState([]);

  const [selectedGender, setSelectedGender] = useState("Male");
  const [updatedSeats, setUpdatedSeats] = useState([]);

  const [currentJourneyId, setCurrentJourneyId] = useState(null);
  const [currentJourneyType, setCurrentJourneyType] = useState("ONWARD");
  const [currentCoachId, setCurrentCoachId] = useState(null);
  const [currentFromCityId, setCurrentFromCityId] = useState(null);
  const [currentToCityId, setCurrentToCityId] = useState(null);

  const [layoutOrientation, setLayoutOrientation] = useState(1);
  const [layoutDisplayCssClass, setLayoutDisplayCssClass] = useState(1);

  const [seatsBookedList, setSeatBookedList] = useState(null);
  const [allSeatDeatils, setAllSeatDeatils] = useState(null);

  const [layoutObject, setLayoutObject] = useState(null);
  const [frompayload, setFormPayload] = useState(null);

  const formref = useRef();

  const [onwardDateFormatWithMonthName, setOnwardDateFormatWithMonthName] =
    useState();
  const [onwardDayName, setOnwardDayname] = useState();

  const [returnDateFormatWithMonthName, setReturnDateFormatWithMonthName] =
    useState();
  const [returnDayName, setReturnDayname] = useState();

  const [isSeatFlipped, setIsSeatFlipped] = useState(false);

  // return Journey State Variables

  const [layoutdataReturn, setLayoutDataReturn] = useState(null);

  const [layoutsListReturn, setLayoutsListReturn] = useState(null);

  const [layoutsArrayDataReturn, setLayoutsArrayDataReturn] = useState(null);

  const [parsedDataReturn, setParsedDataReturn] = useState(null);

  const [isLayoutDataLoadingReturn, setIsLayoutDataLoadingReturn] =
    useState(false);

  const [pickupPointsReturn, setPickupPointsReturn] = useState(null);
  const [droppingPointsReturn, setDroppingPointsReturn] = useState(null);

  const [selectedBoardingReturn, setSelectedBoardingReturn] = useState(null);
  const [selectedDroppingReturn, setSelectedDroppingReturn] = useState(null);

  const [selectedBoardingNameReturn, setSelectedBoardingNameReturn] =
    useState(null);
  const [selectedDroppingNameReturn, setSelectedDroppingNameReturn] =
    useState(null);

  const [selectedSeatsReturn, setSelectedSeatsReturn] = useState([]);

  const [selectedGenderReturn, setSelectedGenderReturn] = useState("Male");
  const [updatedSeatsReturn, setUpdatedSeatsReturn] = useState([]);

  const [currentJourneyIdReturn, setCurrentJourneyIdReturn] = useState(null);
  const [currentJourneyTypeReturn, setCurrentJourneyTypeReturn] =
    useState("RETURN");
  const [currentCoachIdReturn, setCurrentCoachIdReturn] = useState(null);
  const [currentFromCityIdReturn, setCurrentFromCityIdReturn] = useState(null);
  const [currentToCityIdReturn, setCurrentToCityIdReturn] = useState(null);

  const [layoutOrientationReturn, setLayoutOrientationReturn] = useState(1);
  const [layoutDisplayCssClassReturn, setLayoutDisplayCssClassReturn] =
    useState(1);

  const [seatsBookedListReturn, setSeatBookedListReturn] = useState(null);
  const [allSeatDeatilsReturn, setAllSeatDeatilsReturn] = useState(null);

  const [layoutObjectReturn, setLayoutObjectReturn] = useState(null);
  const [frompayloadReturn, setFormPayloadReturn] = useState(null);

  const formrefReturn = useRef();

  const [
    onwardDateFormatWithMonthNameReturn,
    setOnwardDateFormatWithMonthNameReturn,
  ] = useState();
  const [onwardDayNameReturn, setOnwardDaynameReturn] = useState();

  const [
    returnDateFormatWithMonthNameReturn,
    setReturnDateFormatWithMonthNameReturn,
  ] = useState();
  const [returnDayNameReturn, setReturnDaynameReturn] = useState();

  const [isSeatFlippedReturn, setIsSeatFlippedReturn] = useState(false);

  const inputRefs = useRef({});


   const dialogContentRef = useRef(null);



    useEffect(() => {
      console.log("tabValue changed in dailog");
       if(dialogContentRef.current){
        console.log("dialogContentRef.current is not null");
         dialogContentRef.current.scrollTop = 0;
       }
    },[tabValue,tabMainValue,returnTabValue]);




  // Common Operations

  useEffect(() => {
    if (clickedFrom == "onward") {
      setTabMainValue(0);
    }

    if (clickedFrom == "return") {
      setTabMainValue(1);
    }
  }, [clickedFrom]);

  useEffect(() => {
    // console.log("dailogOnwardInputData changed in dailog");
    // console.log(dailogOnwardInputData);
    // if (globalData.journeyType == "onward") {
    //   setGlobalData((prev) => ({
    //     ...prev,
    //     onwardJourneyObject: dailogOnwardInputData
    //       ? dailogOnwardInputData
    //       : prev.onwardJourneyObject,
    //   }));
    // }
    // console.log("dailogReturnInputData changed in dailog");
    // console.log(dailogReturnInputData);
    // if (globalData.journeyType == "return") {
    //   setGlobalData((prev) => ({
    //     ...prev,
    //     returnJourneyObject: dailogReturnInputData
    //       ? dailogReturnInputData
    //       : prev.returnJourneyObject,
    //   }));
    // }
  }, [dailogOnwardInputData, dailogReturnInputData]);

  useEffect(() => {
    // console.log("onwardJourneyObject changed in dailog");
    // console.log(globalData.onwardJourneyObject);

    if (globalData.onwardJourneyObject != null) {
      //console.log("onwardJourneyObject is not null");
      setJourneyOnwardObject(globalData.onwardJourneyObject);
      reinitializeJourneyObjOnward();
    }
    // if(globalData.onwarJourneyData != null){
    //   setSelectedSeats(globalData.onwarJourneyData.selectedSeats);
    // }
  }, [globalData.onwardJourneyObject]);

  useEffect(() => {
    // console.log("returnJourneyObject changed in dailog");
    // console.log(globalData.returnJourneyObject);

    if (globalData.returnJourneyObject != null) {
      //  console.log("returnJourneyObject is not null");
      setJourneyReturnObject(globalData.returnJourneyObject);
      reinitializeJourneyObjReturn();
    }
  }, [globalData.returnJourneyObject]);

  const tabstyles = useMemo(
    () => ({
      color: "#1f1f1f",
      fontWeight: 500,
      fontSize: "13px",
      textTransform: "capitalize",
      padding: "0px 10px",
      height: "35px",
      minHeight: "35px",
      "&.Mui-selected": {
        backgroundColor: "#2D3FA8",
        color: "#fff",
      },
    }),
    [],
  );

  const tabsStyle = useMemo(() => ({ height: "35px", minHeight: "35px" }), []);
  // const handleClose = () => {
  //   setDailogOpen(false);
  // };

  const handleClose = () => {
    dialogClose({ lastDailogOpenValue: false });
  };

  const handleOnwardTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const handleReturnTabChange = (event, newValue) => {
    setReturnTabValue(newValue);
  };
  const handleTabMainChange = (event, newValue) => {
    setTabMainValue(newValue);
  };

  useEffect(() => {
    setTimeout(() => {
      if (globalData.onwardSelectedSeats != null) {
        setSelectedSeats(globalData.onwardSelectedSeats);
      }

      if (globalData.onwardBoardingPoint != null) {
        setSelectedBoarding(globalData.onwardBoardingPoint);
      }

      if (globalData.onwardBoardingName != null) {
        setSelectedBoardingName(globalData.onwardBoardingName);
      }

      if (globalData.onwardDropingPoint != null) {
        setSelectedDropping(globalData.onwardDropingPoint);
      }

      if (globalData.onwardDropingName != null) {
        setSelectedDroppingName(globalData.onwardDropingName);
      }

      // returns journey

      if (globalData.returnSelectedSeats != null) {
        setSelectedSeatsReturn(globalData.returnSelectedSeats);
      }

      if (globalData.returnBoardingPoint != null) {
        setSelectedBoardingReturn(globalData.returnBoardingPoint);
      }

      if (globalData.returnBoardingName != null) {
        setSelectedBoardingNameReturn(globalData.returnBoardingName);
      }

      if (globalData.returnDropingPoint != null) {
        setSelectedDroppingReturn(globalData.returnDropingPoint);
      }

      if (globalData.returnDropingName != null) {
        setSelectedDroppingNameReturn(globalData.returnDropingName);
      }
    }, 300);

    //setDailogOpen(open);
  }, [open]);

  // useEffect(() => {
  //   dialogClose({ lastDailogOpenValue: dailogOpen });
  // }, [dailogOpen]);

  useEffect(() => {
    setTabValue(currentTab);
  }, [currentTab]);

  useEffect(() => {
    // console.log("layoutObject changed");
    // console.log(layoutObject);
  }, [layoutObject]);

  const reinitializeJourneyObjOnward = () => {
    // console.log("initialization Called")
    setTimeout(() => {
      setSelectedSeats([]);
      setSelectedBoarding(null);
      setSelectedBoardingName(null);
      setSelectedDropping(null);
      setSelectedDroppingName(null);
    }, 300);
  };

  const reinitializeJourneyObjReturn = () => {
    // returns journey

    setTimeout(() => {
      setSelectedSeatsReturn([]);
      setSelectedBoardingReturn(null);
      setSelectedBoardingNameReturn(null);
      setSelectedDroppingReturn(null);
      setSelectedDroppingNameReturn(null);
    }, 400);
  };

  useEffect(() => {
    if (layoutOrientation == 1) {
      if (globalData.onwardJourneyObject != null) {
        fetchLayoutDataOnward();
        setLayoutDisplayCssClass("layout-deck-content");
      }

      if (globalData.returnJourneyObject != null) {
        fetchLayoutDataReturn();
        setLayoutDisplayCssClass("layout-deck-content");
      }
    } else {
      if (layoutOrientation == 2) {
        if (globalData.onwardJourneyObject != null) {
          fetchLayoutDataOnward();
          setLayoutDisplayCssClass("layout-deck-content-vertical");
        }

        if (globalData.returnJourneyObject != null) {
          fetchLayoutDataReturn();
          setLayoutDisplayCssClass("layout-deck-content-vertical");
        }
      }
    }
  }, [layoutOrientation]);

  useMemo(() => {
    const onwarddate = globalData.onwardDate;
    const returndate = globalData.returnDate;
    //console.log("Global Dat is" + JSON.stringify(globalData));
    let result_with_slash = onwarddate.replace(/-/g, "/");
    let result = result_with_slash.replace(/\/\s*-/g, "-");
    const parts = result.split(/\D+/);

    //  console.log(parts);
    var day = parseInt(parts[0]);
    var month = parseInt(parts[1]);
    var year = parseInt(parts[2]);

    var dateObject = new Date(year, month - 1, day);
    // console.log(dateObject);
    const options = { month: "short" };
    const monthName = new Intl.DateTimeFormat("en-US", options).format(
      dateObject,
    );

    const dayOptions = { weekday: "long" }; // "short" → Mon, Tue; "narrow" → M, T
    const dayName = new Intl.DateTimeFormat("en-US", dayOptions).format(
      dateObject,
    );
    // console.log("Day:", dayName);
    setOnwardDateFormatWithMonthName(`${day}-${monthName}-${year}`);
    setOnwardDayname(dayName);

    if (
      returndate != null &&
      returndate != undefined &&
      returndate.trim() != ""
    ) {
      let result_with_slash = returndate.replace(/-/g, "/");
      let result = result_with_slash.replace(/\/\s*-/g, "-");
      const parts = result.split(/\D+/);

      //  console.log(parts);
      var day_ret = parseInt(parts[0]);
      var month_ret = parseInt(parts[1]);
      var year_ret = parseInt(parts[2]);

      var dateObject_ret = new Date(year_ret, month_ret - 1, day_ret);
      // console.log(dateObject);
      const options = { month: "short" };
      const monthName = new Intl.DateTimeFormat("en-US", options).format(
        dateObject_ret,
      );

      const dayOptions = { weekday: "long" }; // "short" → Mon, Tue; "narrow" → M, T
      const dayName = new Intl.DateTimeFormat("en-US", dayOptions).format(
        dateObject_ret,
      );
      // console.log("Day:", dayName);
      setReturnDateFormatWithMonthName(`${day_ret}-${monthName}-${year_ret}`);
      setReturnDayname(dayName);
    }
  }, []);

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    getValues,
    watch,

    formState: { errors, isValid },
  } = useForm({
    shouldFocusError: true,
    mode: "onChange",
    // live validation while typing
    defaultValues: {
      mobileOnward: contactDetailsOnward.mobile || "",
      emailOnward: contactDetailsOnward.email || "",
      mobileReturn: contactDetailsReturn.mobile || "",
      emailReturn: contactDetailsReturn.email || "",
      GSTNumberOnward: "",
      GSTNumberReturn: "",
      passengers: updatedSeats.map((s) => ({
        passangerName: s.passangerName || "",
        age: s.age || "",
        gender: s.gender,
      })),

      passengersReturn: updatedSeatsReturn.map((s) => ({
        passangerName: s.passangerName || "",
        age: s.age || "",
        gender: s.gender,
      })),
      
    },
  });

  /*
#######################################################################################################
  // onward Journey Operations
#######################################################################################################
*/

  useEffect(() => {
    // console.log("journeyOnwardObject changed in dailog");
    // console.log(journeyOnwardObject);

    if (journeyOnwardObject != null) {
      // console.log("journeyOnwardObject is not null in dailog useEffect");
      const onwardBusData = journeyOnwardObject.bus;
      //  console.log("onwardBusData in dailog useEffect");
      // console.log(onwardBusData);
      setPickupPoints(onwardBusData.Boardings);
      setDroppingPoints(onwardBusData.Droppings);
      setGstInpercentOnward(onwardBusData.GSTPercent);
      setDiscountInPercentOnward(onwardBusData.DiscountPercent);
      fetchLayoutDataOnward();
      sendEventTobackend("OnwardViewSeatsClicked", null, 1);
    } else {
      // console.log("journeyOnwardObject is null in dailog useEffect");
    }
  }, [journeyOnwardObject]);

  const fetchLayoutDataOnward = useCallback(async () => {
    const templayoutobject = {};
    setIsLayoutDataLoading(true);

    //  console.log("fetchLayoutDataOnward called");
    // console.log(journeyOnwardObject);
    if (journeyOnwardObject != null) {
      // console.log("fetchLayoutDataOnward - onwardJourneyObject is not null");
      const onwardBusData = journeyOnwardObject.bus;
      // console.log(
      //   "fetchLayoutDataOnward - onwardBusData in fetchLayoutDataOnward",
      // );
      // console.log(onwardBusData);

      if (onwardBusData != null && onwardBusData != undefined) {
        setCurrentJourneyId(onwardBusData.JourneyID);
        setCurrentCoachId(onwardBusData.CoachID);
        setCurrentFromCityId(onwardBusData.BFCityID);
        setCurrentToCityId(onwardBusData.BTCityID);

        const layoutDataOnward_url =
          paths.layouturl +
          `?CoachID=${onwardBusData.CoachID}&LayoutType=${layoutOrientation}`;

        const layoutstatusurlpoint_onward =
          paths.journeySeatsInfo +
          `?CoachID=${onwardBusData.CoachID}&JourneyID=${onwardBusData.JourneyID}&FromCityID=${onwardBusData.BFCityID}&ToCityID=${onwardBusData.BTCityID}`;

        try {
          const res1 = await axios.get(`/${layoutstatusurlpoint_onward}`);
          const firstResult = res1.data;
          // console.log("First Result");
          // console.log(firstResult);
          const parsed_first_result = JSON.parse(res1.data.ResponseData);
          // console.log("firstResult parsed");
          // console.log(parsed_first_result);
          if (parsed_first_result) {
            templayoutobject.seatBookedLists =
              parsed_first_result.seatBookedLists;
            templayoutobject.AllSeatDeatils =
              parsed_first_result.AllSeatDeatils;
          }

          const res2 = await axios.get(`/${layoutDataOnward_url}`);
          const secondResult = res2.data;
          //  console.log("second result");
          //  console.log(secondResult);
          if (secondResult.Status) {
            const parsed_second_result = JSON.parse(res2.data.ResponseData);
            //  console.log(parsed_second_result);
            templayoutobject.LayoutStr = parsed_second_result.LayoutStr;
            templayoutobject.SeatIDs = parsed_second_result.SeatIDs;
          } else {
            alert("Layout string data not available");
            return;
          }

          //  console.log(templayoutobject);
          setLayoutObject(templayoutobject);
        } catch (err) {
          console.error("Error in chained calls:", err);
        }
      }
    }
  });

  useEffect(() => {
    // console.log("inuseeffect layoutobject");
    // console.log(layoutObject);

    if (
      layoutObject &&
      layoutObject.seatBookedLists &&
      layoutObject.AllSeatDeatils &&
      layoutObject.LayoutStr
    ) {
      setAllSeatDeatils(layoutObject.AllSeatDeatils);
      setLayoutsArrayData(layoutObject.LayoutStr);
      setSeatBookedList(layoutObject.seatBookedLists);
      setIsLayoutDataLoading(false);

      //  const buttons = document.querySelectorAll('.auto-seat-flip-button');
      //  console.log('buttons');
      //  console.log(buttons);

      // Toggles the 'flipped' class every 3 seconds for this specific button
      setInterval(() => {
        setIsSeatFlipped((prevFlipped) => !prevFlipped);
      }, 2500);
    } else {
      //alert("All layout data not available");
    }
  }, [layoutObject]);

  useEffect(() => {
    // console.log("all seats details");
    // console.log(allSeatDeatils);

    // moving from seatArrayData

    if (layoutsArrayData != null) {
      // console.log("layouts array data updated");
      if (Array.isArray(layoutsArrayData)) {
        if (layoutsArrayData.length > 0) {
          if (seatsBookedList && allSeatDeatils && allSeatDeatils.length > 0) {
            // /////////////////////////////////////////////!SECTION

            const seat_class =
              layoutOrientation === 1
                ? "horizontal-layout-seats-seat"
                : "vertical-layout-seats-seat";
            const templayoutslist = layoutsArrayData.map((layoutItem) => {
              if (
                layoutItem.HTMLString != null &&
                layoutItem.HTMLString != undefined
              ) {
                // console.log("layout item found");
                var idpattern = `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-`;
                const rawString = layoutItem?.HTMLString.replace(
                  /##TDIDPREFIX##/g,
                  `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-`,
                );

                // console.log(rawString);

                const options = {
                  replace: (node) => {
                    if (node.type == "tag" && node.name == "td") {
                      //console.log(node);
                      // console.log(idpattern + "-tdSeatID_0");

                      let html_id = node.attribs.id;

                      const numberd_id = html_id.replace(
                        `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-tdSeatID_`,
                        "",
                      );
                      const seatObject = [...allSeatDeatils];
                      let filteredSeat = seatObject.filter(
                        (item) => item.SeatID == numberd_id,
                      );
                      //alert("Seat Id is " + extract_id + "  the object is" + JSON.stringify(filteredSeat) );

                      let seat_to_pick =
                        filteredSeat?.length == 1 ? filteredSeat[0] : null;

                      return (
                        <td
                          rowSpan={node.attribs.rowspan}
                          colSpan={node.attribs.colspan}
                          style={{ minWidth: "40px" }}
                        >
                          {node.attribs.id === idpattern + "tdSeatID_0" ? (
                            <div> {node.children.map((p) => p.data)} </div>
                          ) : (
                            <div
                              className={`${
                                node.attribs.id === idpattern + "tdSeatID_0"
                                  ? "empty-seats"
                                  : layoutOrientation === 1
                                    ? node.attribs.rowspan == "3"
                                      ? "seat-vertical"
                                      : seat_class
                                    : node.attribs.colspan == "3"
                                      ? "seat-horizontal"
                                      : seat_class
                              } ${
                                checkIsSeatBooked(node.attribs.id) != null
                                  ? checkIsSeatBooked(node.attribs.id) == 1
                                    ? "booked-seat"
                                    : "women-seat"
                                  : checkSeatSelected(node.attribs.id)
                                    ? "seat-checked"
                                    : ""
                              }`}
                              onClick={() => {
                                if (checkIsSeatBooked(node.attribs.id)) {
                                  // console.log("No event attached");
                                } else {
                                  handleTdClick(node.attribs.id);
                                }
                              }}
                              id={node.attribs.id}
                            >
                              {/* <div style={{fontSize:"7px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"1px"}}>
                                    <span > &#8377;{seat_to_pick.FARE} </span>
                                    <span>
                                      
                                    </span>
                                </div> */}
                              {checkIsSeatBooked(node.attribs.id) ? (
                                node.children.map((p) => p.data)
                              ) : (
                                <button
                                  class={`auto-seat-flip-button ${isSeatFlipped ? "flipped-seat" : ""}`}
                                >
                                  <span class="flip-seat-content text-seat-front">
                                    {" "}
                                    {node.children.map((p) => p.data)}{" "}
                                  </span>
                                  <span class="flip-seat-content text-seat-back">
                                    {" "}
                                    &#8377;{seat_to_pick.FARE}
                                  </span>
                                </button>
                              )}

                              <div className="slot"></div>
                            </div>
                          )}
                        </td>
                      );
                    }
                  },
                };

                const pdata = parse(rawString, options);

                return {
                  OrientationType: layoutItem.OrientationType,
                  DeckName: layoutItem.DeckName,
                  DeckDisplayOrder: layoutItem.DeckDisplayOrder,
                  parsedData: pdata,
                };
              }
            });

            setLayoutsList(templayoutslist);

            ///////////////////////////////////////////////
          } else {
            //alert("Seat Details array is empty");
          }
        } else {
          alert("Layout data array is empty");
        }
      } else {
        alert("Layout data is not in expected array format");
      }
    }

    // end of logic
  }, [
    allSeatDeatils,
    allSeatDeatilsReturn,
    seatsBookedList,
    layoutsArrayData,
    layoutsArrayDataReturn,
    selectedSeats,
    isSeatFlipped,
  ]);

  const handleTdClick = (id) => {
    // console.log(id);
    let pattern = `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-tdSeatID_`;
    // console.log(pattern);
    let extract_id = id.replace(pattern, "");
    // console.log(extract_id);

    //alert(layoutdata?.SeatIDs);
    // console.log(layoutdata?.SeatIDs);
    const seatObject = [...allSeatDeatils];
    let filteredSeat = seatObject.filter((item) => item.SeatID == extract_id);
    //alert("Seat Id is " + extract_id + "  the object is" + JSON.stringify(filteredSeat) );

    let seat_to_pick = filteredSeat?.length == 1 ? filteredSeat[0] : null;

    // console.log(selectedSeats.length);
    // if(selectedSeats.length > 5){

    // }else{
    //   console.log('asd');
    // }

    toggleSeatSelected(seat_to_pick);
  };

  const selectedSeatIds = useMemo(
    () => new Set(selectedSeats.map((s) => s.SeatID)),
    [selectedSeats],
  );

  useEffect(() => {
    // console.log(selectedSeatIds);
  }, [selectedSeatIds]);

  const bookedSeatIds = useMemo(
    () => new Set(seatsBookedList?.map((s) => s.SeatID)),
    [seatsBookedList],
  );

  const bookedSeatMap = useMemo(
    () => new Map(seatsBookedList?.map((s) => [s.SeatID, s])),
    [seatsBookedList],
  );

  const checkSeatSelected = useCallback(
    (id) => {
      const extract_id = id.replace(
        `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-tdSeatID_`,
        "",
      );
      // console.log(selectedSeatIds);
      // console.log(extract_id);
      // console.log("THis is the select seat ");
      return selectedSeatIds.has(Number(extract_id));
    },
    [selectedSeatIds],
  );

  const checkIsSeatBooked = useCallback(
    (id) => {
      const extract_id = id.replace(
        `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-tdSeatID_`,
        "",
      );
      // console.log(extract_id);
      //return bookedSeatIds?.has(Number(extract_id));

      const seat = bookedSeatMap.get(Number(extract_id));

      if (seat) {
        return seat.Gender;
      }

      return null;
    },
    [bookedSeatIds],
  );

  function replaceProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleBoardingPointChange = (event) => {
    setSelectedBoarding(event.target.value);
    sendEventTobackend("OnwardBoardingPointSelected", null, 1);
    setGlobalData((prev) => ({
      ...prev,

      onwardBoardingPoint: event.target.value,
    }));
    const bobj = pickupPoints.filter(
      (item) => item.BoardingPointID == event.target.value,
    );
    //console.log(bobj);
    if (bobj.length > 0) {
      setSelectedBoardingName(bobj[0]);
      setGlobalData((prev) => ({
        ...prev,

        onwardBoardingName: bobj[0],
      }));
    }

    if(dialogContentRef.current){
      dialogContentRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }


  };

  const handleDroppingPointChange = (event) => {
    setSelectedDropping(event.target.value);
    sendEventTobackend("OnwardDroppingPointSelected", null, 1);
    setGlobalData((prev) => ({
      ...prev,

      onwardDropingPoint: event.target.value,
    }));
    const bobj = droppingPoints.filter(
      (item) => item.BoardingPointID == event.target.value,
    );
    //console.log(bobj);
    if (bobj.length > 0) {
      //console.log("its length is more than 1");
      setSelectedDroppingName(bobj[0]);
      setGlobalData((prev) => ({
        ...prev,

        onwardDropingName: bobj[0],
      }));
    }
  };

  const toggleSeatSelected = (seat) => {
    const updated = selectedSeats?.some((s) => s.SeatID === seat.SeatID)
      ? selectedSeats.filter((item) => item.SeatID !== seat.SeatID)
      : [...selectedSeats, seat];

    if (updated?.length <= 6) {
      setSelectedSeats(updated);
      setGlobalData((prev) => ({
        ...prev,
        onwardSelectedSeats: updated,
      }));
    } else {
      console.log("Length > 6");
    }

    sendEventTobackend("OnwardSeatsSelected", null, 1);

    // setSelectedSeats((prev) =>
    //   prev?.some((s) => s.SeatID === seat.SeatID)
    //     ? prev.filter((item) => item.SeatID !== seat.SeatID)
    //     : prev.length > 5
    //       ? [...prev]
    //       : [...prev, seat],
    // );

    //  setGlobalData((prev)=>({
    //   ...prev,
    //   onwarJourneyData : {
    //     onwardSelectedSeats: selectedSeats
    //   }
    //  }))
  };

  useEffect(() => {
    // console.log(selectedSeats);
    // const ordered_Seats = selectedSeats.orderBy(selectedSeats,["SeatNumber"],["asc"]);
    // setSelectedSeats(ordered_Seats);
    if (selectedSeats.length > 5) {
      alert("You can select maximum of 6 seats");
    }
    let sub_sum = 0;
    // let discount = 0;
    // let gst = 0;
    selectedSeats.forEach((seat) => {
      sub_sum += seat.FARE;
    });

    setSubTotalOnward(sub_sum);
    setGrandwithoutDiscOnward(sub_sum);
    setDiscountOnward((sub_sum * discountInPercentOnward) / 100);
    setTotalGstOnward((sub_sum * gstInpercentOnward) / 100);

    const seatsWithSelectedAttribe = selectedSeats.map((item) => ({
      ...item,
      passangerName: null,
      age: null,
      gender: false,
    }));
    setUpdatedSeats(seatsWithSelectedAttribe);
  }, [selectedSeats]);

  const handleGenderChange = (SeatNumber) => {
    const currentValues = getValues();
    sendEventTobackend("OnwardGenderSelected", null, 1);
    const seatsGenderUpdated = updatedSeats.map((seat, index) => {
      if (seat.SeatNumber === SeatNumber) {
        // Get passenger data from current form values
        const passengerData = currentValues.passengers?.[index] || {};

        return {
          ...seat,
          gender: !seat.gender,
          passangerName: passengerData.passangerName || seat.passangerName,
          age: passengerData.age || seat.age,
        };
      }
      return seat;
    });

    setUpdatedSeats(seatsGenderUpdated); // Make sure to update the state
  };

  const handleMaleIconClick = (SeatNumber) => {
    const currentValues = getValues();

    const seatsGenderUpdated = updatedSeats.map((seat, index) => {
      if (seat.SeatNumber === SeatNumber) {
        // Get passenger data from current form values
        const passengerData = currentValues.passengers?.[index] || {};

        return {
          ...seat,
          gender: false,
          passangerName: passengerData.passangerName || seat.passangerName,
          age: passengerData.age || seat.age,
        };
      }
      return seat;
    });

    setUpdatedSeats(seatsGenderUpdated);
  };

  const handleFeMaleIconClick = (SeatNumber) => {
    const currentValues = getValues();

    const seatsGenderUpdated = updatedSeats.map((seat, index) => {
      if (seat.SeatNumber === SeatNumber) {
        // Get passenger data from current form values
        const passengerData = currentValues.passengers?.[index] || {};

        return {
          ...seat,
          gender: true,
          passangerName: passengerData.passangerName || seat.passangerName,
          age: passengerData.age || seat.age,
        };
      }
      return seat;
    });

    setUpdatedSeats(seatsGenderUpdated);
  };

  useEffect(() => {
    // console.log(selectedGender);
  }, [selectedGender]);

  const handleBookNow = () => {
    // window.location.href = `${paymentUrl}`
    //window.location.replace(paymentUrl);
  };

  // useEffect(()=>{

  //    console.log("selected seats affecting");

  // },[selectedSeats])

  useEffect(() => {
    console.log("the global data is here");
    console.log(globalData);

     if(globalData.SignedPassenger.IsPassengerSignedIn == 1){
      setContactDetailsOnward({
        mobileOnward:globalData.SignedPassenger.SignedPassenger?.MobileNumber,
        email:""
      })
      setContactDetailsReturn({
        mobileReturn:globalData.SignedPassenger.SignedPassenger?.MobileNumber,
        email:""
      })
      setValue("mobileOnward", globalData.SignedPassenger.SignedPassenger?.MobileNumber, { shouldValidate: true });
      setValue("mobileReturn", globalData.SignedPassenger.SignedPassenger?.MobileNumber, { shouldValidate: true });
     }







  }, [globalData]);

  useEffect(() => {
    setGrandTotalOnward(0);
    setGrandwithoutDiscOnward(subtotalOnward);
    const total = subtotalOnward - discountOnward;
    if (gstInpercentOnward != null) {
      const gst = (total * gstInpercentOnward) / 100;
      setTotalGstOnward(gst);
      const grand_total = total + gst;
      setGrandTotalOnward(grand_total);
    }
  }, [selectedSeats, subtotalOnward, discountOnward, totalGstOnward]);





  const tooltipContentOnward = (
      <Box sx={{ width: 'auto',maxWith:'650px', p: 1.5 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, fontSize: '12px' }}>
          Fare Breakdown:
        </Typography>
  
        {/* Header Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '2px',
            mb: 1,
            fontSize: '12px',
            fontWeight: 600,
          }}
        >
          <span>Seat</span>
          <span style={{ textAlign: 'right' }}>Fare</span>
          <span style={{ textAlign: 'right' }}>Disc(%)</span>
          <span style={{ textAlign: 'right' }}>Discount</span>
          <span style={{ textAlign: 'right' }}>Amount</span>
        </Box>
  
        {/* Seat Rows */}
        {updatedSeats?.map((item, idx) => (
          <Box
            key={idx}
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
              gap: '2px',
              fontSize: '12px',
              mb: 0.5,
            }}
          >
            <span>{item.SeatNumber}</span>
            <span style={{ textAlign: 'right' }}>₹ {item.FARE.toFixed(2) || 'N/A'}</span>
            <span style={{ textAlign: 'right' }}>{discountInPercentOnward}%</span>
            <span style={{ textAlign: 'right' }}>₹ {(item.FARE * discountInPercentOnward / 100).toFixed(2)}</span>
            <span style={{ fontWeight: 600, textAlign: 'right' }}>
              ₹ {(item.FARE - (item.FARE * discountInPercentOnward / 100)).toFixed(2)}
            </span>
          </Box>
        ))}
  
        {/* Total Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '8px',
            fontSize: '13px',
            fontWeight: 600,
            borderTop: '1px dashed #2D3FA8',
            pt: 1,
            mt: 1,
            mb: 0.5,
          }}
        >
          <span>Total</span>
          <span style={{ textAlign: 'right' }}>₹ {subtotalOnward.toFixed(2)}</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>₹ {discountOnward.toFixed(2)}</span>
          <span style={{ textAlign: 'right' }}>₹ {(subtotalOnward - discountOnward).toFixed(2)}</span>
        </Box>
  
        {/* GST Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '8px',
            fontSize: '13px',
            mb: 0.5,
          }}
        >
          <span>GST</span>
          <span style={{ textAlign: 'right' }}> {gstInpercentOnward}% </span>
          <span style={{ textAlign: 'right' }}> - </span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>₹ {totalGstOnward.toFixed(2)}</span>
        </Box>
  
        {/* Grand Total Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '8px',
            fontSize: '13px',
            fontWeight: 700,
            borderTop: '1px dashed #2D3FA8',
            pt: 1,
          }}
        >
          <span>Grand Total</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>₹ {grandTotalOnward.toFixed(2)}</span>
        </Box>
      </Box>
    );

  /*
########################################################################################################
  // onward Journey Operations  Ends
#########################################################################################################
*/

  /*
@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // return Journey Operations
@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
*/

  useEffect(() => {
    // console.log("journeyRetuen changed in dailog");
    // console.log(journeyReturnObject);

    if (journeyReturnObject != null) {
      // console.log("journeyReturnObject is not null in dailog useEffect");
      const returnBusData = journeyReturnObject.bus;
      // console.log("returnBusData in dailog useEffect");
      //  console.log(returnBusData);
      setPickupPointsReturn(returnBusData.Boardings);
      setDroppingPointsReturn(returnBusData.Droppings);
      setGstInpercentReturn(returnBusData.GSTPercent);
      setDiscountInPercentReturn(returnBusData.DiscountPercent);
      fetchLayoutDataReturn();
      sendEventTobackend("ReturnViewSeatsClicked", null, 1);
    } else {
      console.log("journeyReturnObject is null in dailog useEffect");
    }
  }, [journeyReturnObject]);

  const fetchLayoutDataReturn = useCallback(async () => {
    const templayoutobject = {};
    setIsLayoutDataLoadingReturn(true);

    console.log("fetchLayoutDataReturn called");
    console.log(journeyReturnObject);
    if (journeyReturnObject != null) {
      console.log("fetchLayoutDataReturn - returnJourneyObject is not null");
      const returnBusData = journeyReturnObject.bus;
      console.log(
        "fetchLayoutDataReturn - returnBusData in fetchLayoutDataReturn",
      );
      console.log(returnBusData);

      if (returnBusData != null && returnBusData != undefined) {
        setCurrentJourneyIdReturn(returnBusData.JourneyID);
        setCurrentCoachIdReturn(returnBusData.CoachID);
        setCurrentFromCityIdReturn(returnBusData.BFCityID);
        setCurrentToCityIdReturn(returnBusData.BTCityID);

        const layoutDataReturn_url =
          paths.layouturl +
          `?CoachID=${returnBusData.CoachID}&LayoutType=${layoutOrientation}`;

        const layoutstatusurlpoint_return =
          paths.journeySeatsInfo +
          `?CoachID=${returnBusData.CoachID}&JourneyID=${returnBusData.JourneyID}&FromCityID=${returnBusData.BFCityID}&ToCityID=${returnBusData.BTCityID}`;

        try {
          const res1 = await axios.get(`/${layoutstatusurlpoint_return}`);
          const firstResult = res1.data;
          console.log("First Result");
          console.log(firstResult);
          const parsed_first_result = JSON.parse(res1.data.ResponseData);
          console.log("firstResult parsed");
          console.log(parsed_first_result);
          if (parsed_first_result) {
            templayoutobject.seatBookedLists =
              parsed_first_result.seatBookedLists;
            templayoutobject.AllSeatDeatils =
              parsed_first_result.AllSeatDeatils;
          }

          const res2 = await axios.get(`/${layoutDataReturn_url}`);
          const secondResult = res2.data;
          console.log("second result");
          console.log(secondResult);
          if (secondResult.Status) {
            const parsed_second_result = JSON.parse(res2.data.ResponseData);
            console.log(parsed_second_result);
            templayoutobject.LayoutStr = parsed_second_result.LayoutStr;
            templayoutobject.SeatIDs = parsed_second_result.SeatIDs;
          } else {
            alert("Layout string data not available");
            return;
          }

          console.log(templayoutobject);
          setLayoutObjectReturn(templayoutobject);
        } catch (err) {
          console.error("Error in chained calls:", err);
        }
      }
    }
  });

  useEffect(() => {
    // console.log("inuseeffect layoutobject");
    // console.log(layoutObject);

    // console.log("layoutObjectReturn changed");
    // console.log(layoutObjectReturn);

    if (
      layoutObjectReturn &&
      layoutObjectReturn.seatBookedLists &&
      layoutObjectReturn.AllSeatDeatils &&
      layoutObjectReturn.LayoutStr
    ) {
      console.log("All layout data is available for return journey");

      setAllSeatDeatilsReturn(layoutObjectReturn.AllSeatDeatils);
      setLayoutsArrayDataReturn(layoutObjectReturn.LayoutStr);
      setSeatBookedListReturn(layoutObjectReturn.seatBookedLists);
      setIsLayoutDataLoadingReturn(false);

      //  const buttons = document.querySelectorAll('.auto-seat-flip-button');
      //  console.log('buttons');
      //  console.log(buttons);

      // Toggles the 'flipped' class every 3 seconds for this specific button
      setInterval(() => {
        setIsSeatFlippedReturn((prevFlipped) => !prevFlipped);
      }, 2500);
    } else {
      //alert("All layout data not available");
    }
  }, [layoutObjectReturn]);

  // useEffect(() => {
  //   console.log("setIsLayoutDataLoadingReturn changed");
  //   console.log(isLayoutDataLoadingReturn);
  // }, [isLayoutDataLoadingReturn]);

  useEffect(() => {
    // console.log("all seats details");
    // console.log(allSeatDeatils);

    // moving from seatArrayData

    if (layoutsArrayDataReturn != null) {
      // console.log("layouts array data updated");
      if (Array.isArray(layoutsArrayDataReturn)) {
        if (layoutsArrayDataReturn.length > 0) {
          if (
            seatsBookedListReturn &&
            allSeatDeatilsReturn &&
            allSeatDeatilsReturn.length > 0
          ) {
            // /////////////////////////////////////////////!SECTION

            const seat_class =
              layoutOrientation === 1
                ? "horizontal-layout-seats-seat"
                : "vertical-layout-seats-seat";
            const templayoutslist = layoutsArrayDataReturn.map((layoutItem) => {
              if (
                layoutItem.HTMLString != null &&
                layoutItem.HTMLString != undefined
              ) {
                // console.log("layout item found");
                var idpattern = `${currentJourneyIdReturn}-${currentJourneyType}-${currentCoachIdReturn}-`;
                const rawString = layoutItem?.HTMLString.replace(
                  /##TDIDPREFIX##/g,
                  `${currentJourneyIdReturn}-${currentJourneyType}-${currentCoachIdReturn}-`,
                );

                // console.log(rawString);

                const options = {
                  replace: (node) => {
                    if (node.type == "tag" && node.name == "td") {
                      //console.log(node);
                      // console.log(idpattern + "-tdSeatID_0");

                      let html_id = node.attribs.id;

                      const numberd_id = html_id.replace(
                        `${currentJourneyIdReturn}-${currentJourneyType}-${currentCoachIdReturn}-tdSeatID_`,
                        "",
                      );
                      const seatObject = [...allSeatDeatilsReturn];
                      let filteredSeat = seatObject.filter(
                        (item) => item.SeatID == numberd_id,
                      );
                      //alert("Seat Id is " + extract_id + "  the object is" + JSON.stringify(filteredSeat) );

                      let seat_to_pick =
                        filteredSeat?.length == 1 ? filteredSeat[0] : null;

                      return (
                        <td
                          rowSpan={node.attribs.rowspan}
                          colSpan={node.attribs.colspan}
                          style={{ minWidth: "40px" }}
                        >
                          {node.attribs.id === idpattern + "tdSeatID_0" ? (
                            <div> {node.children.map((p) => p.data)} </div>
                          ) : (
                            <div
                              className={`${
                                node.attribs.id === idpattern + "tdSeatID_0"
                                  ? "empty-seats"
                                  : layoutOrientation === 1
                                    ? node.attribs.rowspan == "3"
                                      ? "seat-vertical"
                                      : seat_class
                                    : node.attribs.colspan == "3"
                                      ? "seat-horizontal"
                                      : seat_class
                              } ${
                                checkIsSeatBookedReturn(node.attribs.id) != null
                                  ? checkIsSeatBookedReturn(node.attribs.id) ==
                                    1
                                    ? "booked-seat"
                                    : "women-seat"
                                  : checkSeatSelectedReturn(node.attribs.id)
                                    ? "seat-checked"
                                    : ""
                              }`}
                              onClick={() => {
                                if (checkIsSeatBookedReturn(node.attribs.id)) {
                                  // console.log("No event attached");
                                } else {
                                  handleTdClickReturn(node.attribs.id);
                                }
                              }}
                              id={node.attribs.id}
                            >
                              {/* <div style={{fontSize:"7px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"1px"}}>
                                    <span > &#8377;{seat_to_pick.FARE} </span>
                                    <span>
                                      
                                    </span>
                                </div> */}
                              {checkIsSeatBookedReturn(node.attribs.id) ? (
                                node.children.map((p) => p.data)
                              ) : (
                                <button
                                  class={`auto-seat-flip-button ${isSeatFlippedReturn ? "flipped-seat" : ""}`}
                                >
                                  <span class="flip-seat-content text-seat-front">
                                    {" "}
                                    {node.children.map((p) => p.data)}{" "}
                                  </span>
                                  <span class="flip-seat-content text-seat-back">
                                    {" "}
                                    &#8377;{seat_to_pick.FARE}
                                  </span>
                                </button>
                              )}

                              <div className="slot"></div>
                            </div>
                          )}
                        </td>
                      );
                    }
                  },
                };

                const pdata = parse(rawString, options);

                return {
                  OrientationType: layoutItem.OrientationType,
                  DeckName: layoutItem.DeckName,
                  DeckDisplayOrder: layoutItem.DeckDisplayOrder,
                  parsedData: pdata,
                };
              }
            });

            setLayoutsListReturn(templayoutslist);

            ///////////////////////////////////////////////
          } else {
            //alert("Seat Details array is empty");
          }
        } else {
          alert("Layout data array is empty");
        }
      } else {
        alert("Layout data is not in expected array format");
      }
    }

    // end of logic
  }, [
    allSeatDeatilsReturn,
    allSeatDeatilsReturn,
    seatsBookedListReturn,
    layoutsArrayDataReturn,
    layoutsArrayDataReturn,
    selectedSeatsReturn,
    isSeatFlippedReturn,
  ]);

  const handleTdClickReturn = (id) => {
    // console.log(id);
    let pattern = `${currentJourneyIdReturn}-${currentJourneyType}-${currentCoachIdReturn}-tdSeatID_`;
    // console.log(pattern);
    let extract_id = id.replace(pattern, "");
    // console.log(extract_id);

    //alert(layoutdata?.SeatIDs);
    // console.log(layoutdata?.SeatIDs);
    const seatObject = [...allSeatDeatilsReturn];
    let filteredSeat = seatObject.filter((item) => item.SeatID == extract_id);
    //alert("Seat Id is " + extract_id + "  the object is" + JSON.stringify(filteredSeat) );

    let seat_to_pick = filteredSeat?.length == 1 ? filteredSeat[0] : null;

    // console.log(selectedSeats.length);
    // if(selectedSeats.length > 5){

    // }else{
    //   console.log('asd');
    // }

    toggleSeatSelectedReturn(seat_to_pick);
  };

  const selectedSeatIdsReturn = useMemo(
    () => new Set(selectedSeatsReturn.map((s) => s.SeatID)),
    [selectedSeatsReturn],
  );

  useEffect(() => {
    // console.log(selectedSeatIds);
  }, [selectedSeatIdsReturn]);

  const bookedSeatIdsReturn = useMemo(
    () => new Set(seatsBookedListReturn?.map((s) => s.SeatID)),
    [seatsBookedListReturn],
  );

  const bookedSeatMapReturn = useMemo(
    () => new Map(seatsBookedListReturn?.map((s) => [s.SeatID, s])),
    [seatsBookedListReturn],
  );

  const checkSeatSelectedReturn = useCallback(
    (id) => {
      const extract_id = id.replace(
        `${currentJourneyIdReturn}-${currentJourneyType}-${currentCoachIdReturn}-tdSeatID_`,
        "",
      );
      // console.log(selectedSeatIds);
      // console.log(extract_id);
      // console.log("THis is the select seat ");
      return selectedSeatIdsReturn.has(Number(extract_id));
    },
    [selectedSeatIdsReturn],
  );

  const checkIsSeatBookedReturn = useCallback(
    (id) => {
      const extract_id = id.replace(
        `${currentJourneyIdReturn}-${currentJourneyType}-${currentCoachIdReturn}-tdSeatID_`,
        "",
      );
      // console.log(extract_id);
      //return bookedSeatIdsReturn?.has(Number(extract_id));

      const seat = bookedSeatMapReturn.get(Number(extract_id));

      if (seat) {
        return seat.Gender;
      }

      return null;
    },
    [bookedSeatMapReturn],
  );

  //     function replaceProps(index) {
  //   return {
  //     id: `simple-tab-${index}`,
  //     "aria-controls": `simple-tabpanel-${index}`,
  //   };
  // }

  const handleBoardingPointChangeReturn = (event) => {
    setSelectedBoardingReturn(event.target.value);
    sendEventTobackend("ReturnBoardingPointSelected", null, 1);
    setGlobalData((prev) => ({
      ...prev,

      returnBoardingPoint: event.target.value,
    }));
    const bobj = pickupPointsReturn.filter(
      (item) => item.BoardingPointID == event.target.value,
    );
    //console.log(bobj);
    if (bobj.length > 0) {
      setSelectedBoardingNameReturn(bobj[0]);

      setGlobalData((prev) => ({
        ...prev,

        returnBoardingName: bobj[0],
      }));
    }

    if (dialogContentRef.current) {
      dialogContentRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleDroppingPointChangeReturn = (event) => {
    setSelectedDroppingReturn(event.target.value);
    sendEventTobackend("ReturnDroppingPointSelected", null, 1);
    setGlobalData((prev) => ({
      ...prev,

      returnDropingPoint: event.target.value,
    }));

    const bobj = droppingPointsReturn.filter(
      (item) => item.BoardingPointID == event.target.value,
    );
    //console.log(bobj);
    if (bobj.length > 0) {
      //console.log("its length is more than 1");
      setSelectedDroppingNameReturn(bobj[0]);
      setGlobalData((prev) => ({
        ...prev,

        returnDropingName: bobj[0],
      }));
    }
  };

  const toggleSeatSelectedReturn = (seat) => {
    // setSelectedSeatsReturn((prev) =>
    //   prev?.some((s) => s.SeatID === seat.SeatID)
    //     ? prev.filter((item) => item.SeatID !== seat.SeatID)
    //     : prev.length > 5
    //       ? [...prev]
    //       : [...prev, seat],
    // );

    const updated = selectedSeatsReturn?.some((s) => s.SeatID === seat.SeatID)
      ? selectedSeatsReturn.filter((item) => item.SeatID !== seat.SeatID)
      : [...selectedSeatsReturn, seat];

    if (updated?.length <= 6) {
      setSelectedSeatsReturn(updated);
      setGlobalData((prev) => ({
        ...prev,
        returnSelectedSeats: updated,
      }));
    } else {
      console.log("Length > 6");
    }

    sendEventTobackend("ReturnSeatsSelected", null, 1);
  };

  useEffect(() => {
    // console.log(selectedSeats);
    // const ordered_Seats = selectedSeats.orderBy(selectedSeats,["SeatNumber"],["asc"]);
    // setSelectedSeats(ordered_Seats);
    if (selectedSeatsReturn.length > 5) {
      alert("You can select maximum of 6 seats");
    }
    let sub_sum = 0;
    // let discount = 0;
    // let gst = 0;
    selectedSeatsReturn.forEach((seat) => {
      sub_sum += seat.FARE;
    });

    setSubTotalReturn(sub_sum);
    setGrandwithoutDiscReturn(sub_sum);
    setDiscountReturn((sub_sum * discountInPercentReturn) / 100);
    setTotalGstReturn((sub_sum * gstInpercentReturn) / 100);

    const seatsWithSelectedAttribe = selectedSeatsReturn.map((item) => ({
      ...item,
      passangerName: null,
      age: null,
      gender: false,
    }));
    setUpdatedSeatsReturn(seatsWithSelectedAttribe);
  }, [selectedSeatsReturn]);

  useEffect(() => {
    setGrandTotalReturn(0);
    setGrandwithoutDiscReturn(subtotalReturn);
    const total = subtotalReturn - discountReturn;
    //  console.log("the total return is ");
    //  console.log(total);
    if (gstInpercentReturn != null) {
      const gst = (total * gstInpercentReturn) / 100;
      setTotalGstReturn(gst);
      const grand_total = total + gst;
      setGrandTotalReturn(grand_total);
    }
  }, [selectedSeatsReturn, subtotalReturn, discountReturn, totalGstReturn]);


   const tooltipContentReturn = (
      <Box sx={{ width: 'auto',maxWith:'650px', p: 1.5 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, fontSize: '12px' }}>
          Fare Breakdown:
        </Typography>
  
        {/* Header Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '2px',
            mb: 1,
            fontSize: '12px',
            fontWeight: 600,
          }}
        >
          <span>Seat</span>
          <span style={{ textAlign: 'right' }}>Fare</span>
          <span style={{ textAlign: 'right' }}>Disc(%)</span>
          <span style={{ textAlign: 'right' }}>Discount</span>
          <span style={{ textAlign: 'right' }}>Amount</span>
        </Box>
  
        {/* Seat Rows */}
        {updatedSeatsReturn?.map((item, idx) => (
          <Box
            key={idx}
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
              gap: '2px',
              fontSize: '12px',
              mb: 0.5,
            }}
          >
            <span>{item.SeatNumber}</span>
            <span style={{ textAlign: 'right' }}>₹ {item.FARE.toFixed(2) || 'N/A'}</span>
            <span style={{ textAlign: 'right' }}>{discountInPercentReturn}%</span>
            <span style={{ textAlign: 'right' }}>₹ {(item.FARE * discountInPercentReturn / 100).toFixed(2)}</span>
            <span style={{ fontWeight: 600, textAlign: 'right' }}>
              ₹ {(item.FARE - (item.FARE * discountInPercentReturn / 100)).toFixed(2)}
            </span>
          </Box>
        ))}
  
        {/* Total Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '8px',
            fontSize: '13px',
            fontWeight: 600,
            borderTop: '1px dashed #2D3FA8',
            pt: 1,
            mt: 1,
            mb: 0.5,
          }}
        >
          <span>Total</span>
          <span style={{ textAlign: 'right' }}>₹ {subtotalReturn.toFixed(2)}</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>₹ {discountReturn.toFixed(2)}</span>
          <span style={{ textAlign: 'right' }}>₹ {(subtotalReturn - discountReturn).toFixed(2)}</span>
        </Box>
  
        {/* GST Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '8px',
            fontSize: '13px',
            mb: 0.5,
          }}
        >
          <span>GST</span>
          <span style={{ textAlign: 'right' }}> {gstInpercentReturn}% </span>
          <span style={{ textAlign: 'right' }}> - </span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>₹ {totalGstReturn.toFixed(2)}</span>
        </Box>
  
        {/* Grand Total Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '8px',
            fontSize: '13px',
            fontWeight: 700,
            borderTop: '1px dashed #2D3FA8',
            pt: 1,
          }}
        >
          <span>Grand Total</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>₹ {grandTotalReturn.toFixed(2)}</span>
        </Box>
      </Box>
    );










  /*
@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // return Journey Operations Ends
@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
 
 */

  /*

  













$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
Submit
$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$


*/




  const  tooltipContentBoth = (
  
    <Box sx={{padding:"10px", display:"flex", flexDirection:"column"}}
    >

       <Box sx={{ width: 'auto',maxWith:'650px', p: 1.5 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, fontSize: '12px' }}>
          Fare Breakdown Onward:
        </Typography>
  
        {/* Header Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '2px',
            mb: 1,
            fontSize: '12px',
            fontWeight: 600,
          }}
        >
          <span>Seat</span>
          <span style={{ textAlign: 'right' }}>Fare</span>
          <span style={{ textAlign: 'right' }}>Disc(%)</span>
          <span style={{ textAlign: 'right' }}>Discount</span>
          <span style={{ textAlign: 'right' }}>Amount</span>
        </Box>
  
        {/* Seat Rows */}
        {updatedSeats?.map((item, idx) => (
          <Box
            key={idx}
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
              gap: '2px',
              fontSize: '12px',
              mb: 0.5,
            }}
          >
            <span>{item.SeatNumber}</span>
            <span style={{ textAlign: 'right' }}>₹ {item.FARE.toFixed(2) || 'N/A'}</span>
            <span style={{ textAlign: 'right' }}>{discountInPercentOnward}%</span>
            <span style={{ textAlign: 'right' }}>₹ {(item.FARE * discountInPercentOnward / 100).toFixed(2)}</span>
            <span style={{ fontWeight: 600, textAlign: 'right' }}>
              ₹ {(item.FARE - (item.FARE * discountInPercentOnward / 100)).toFixed(2)}
            </span>
          </Box>
        ))}
  
        {/* Total Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '8px',
            fontSize: '13px',
            fontWeight: 600,
            borderTop: '1px dashed #2D3FA8',
            pt: 1,
            mt: 1,
            mb: 0.5,
          }}
        >
          <span>Total</span>
          <span style={{ textAlign: 'right' }}>₹ {subtotalOnward.toFixed(2)}</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>₹ {discountOnward.toFixed(2)}</span>
          <span style={{ textAlign: 'right' }}>₹ {(subtotalOnward - discountOnward).toFixed(2)}</span>
        </Box>
  
        {/* GST Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '8px',
            fontSize: '13px',
            mb: 0.5,
          }}
        >
          <span>GST</span>
          <span style={{ textAlign: 'right' }}> {gstInpercentOnward}% </span>
          <span style={{ textAlign: 'right' }}> - </span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>₹ {totalGstOnward.toFixed(2)}</span>
        </Box>
  
        {/* Grand Total Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '8px',
            fontSize: '13px',
            fontWeight: 700,
            borderTop: '1px dashed #2D3FA8',
            pt: 1,
          }}
        >
          <span>Grand Total</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>₹ {grandTotalOnward.toFixed(2)}</span>
        </Box>
      </Box>
	  
	  
	  
	  
	  
	  <Box sx={{ width: 'auto',maxWith:'650px', p: 1.5 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, fontSize: '12px' }}>
          Fare Breakdown Return:
        </Typography>
  
        {/* Header Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '2px',
            mb: 1,
            fontSize: '12px',
            fontWeight: 600,
          }}
        >
          <span>Seat</span>
          <span style={{ textAlign: 'right' }}>Fare</span>
          <span style={{ textAlign: 'right' }}>Disc(%)</span>
          <span style={{ textAlign: 'right' }}>Discount</span>
          <span style={{ textAlign: 'right' }}>Amount</span>
        </Box>
  
        {/* Seat Rows */}
        {updatedSeatsReturn?.map((item, idx) => (
          <Box
            key={idx}
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
              gap: '2px',
              fontSize: '12px',
              mb: 0.5,
            }}
          >
            <span>{item.SeatNumber}</span>
            <span style={{ textAlign: 'right' }}>₹ {item.FARE.toFixed(2) || 'N/A'}</span>
            <span style={{ textAlign: 'right' }}>{discountInPercentReturn}%</span>
            <span style={{ textAlign: 'right' }}>₹ {(item.FARE * discountInPercentReturn / 100).toFixed(2)}</span>
            <span style={{ fontWeight: 600, textAlign: 'right' }}>
              ₹ {(item.FARE - (item.FARE * discountInPercentReturn / 100)).toFixed(2)}
            </span>
          </Box>
        ))}
  
        {/* Total Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '8px',
            fontSize: '13px',
            fontWeight: 600,
            borderTop: '1px dashed #2D3FA8',
            pt: 1,
            mt: 1,
            mb: 0.5,
          }}
        >
          <span>Total</span>
          <span style={{ textAlign: 'right' }}>₹ {subtotalReturn.toFixed(2)}</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>₹ {discountReturn.toFixed(2)}</span>
          <span style={{ textAlign: 'right' }}>₹ {(subtotalReturn - discountReturn).toFixed(2)}</span>
        </Box>
  
        {/* GST Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '8px',
            fontSize: '13px',
            mb: 0.5,
          }}
        >
          <span>GST</span>
          <span style={{ textAlign: 'right' }}> {gstInpercentReturn}% </span>
          <span style={{ textAlign: 'right' }}> - </span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>₹ {totalGstReturn.toFixed(2)}</span>
        </Box>
  
        {/* Grand Total Row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '8px',
            fontSize: '13px',
            fontWeight: 700,
            borderTop: '1px dashed #2D3FA8',
            pt: 1,
          }}
        >
          <span>Grand Total</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>₹ {grandTotalReturn.toFixed(2)}</span>
        </Box>
      </Box>


      <Box sx={{ width: 'auto',maxWith:'650px', p: 1.5 }}>


         <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '8px',
            fontSize: '13px',
            fontWeight: 700,
            borderTop: '1px dashed #2D3FA8',
            pt: 1,
          }}
        >
          <span> </span>
          <span style={{ textAlign: 'right' }}>Onward </span>
          <span style={{ textAlign: 'right' }}>Return</span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>-</span>
        </Box>



        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '8px',
            fontSize: '13px',
            fontWeight: 700,
            borderTop: '1px dashed #2D3FA8',
            pt: 1,
          }}
        >
          <span> Round Trip Amount </span>
          <span style={{ textAlign: 'right' }}> { (grandTotalOnward).toFixed(2)} </span>
          <span style={{ textAlign: 'right' }}> { (grandTotalReturn).toFixed(2)} </span>
          <span style={{ textAlign: 'right' }}>-</span>
          <span style={{ textAlign: 'right' }}>{(grandTotalOnward+grandTotalReturn).toFixed(2)}</span>
        </Box>





      </Box>



      







    </Box>
  
  
  
  
  
  
  
  
  
  
  
  
  );

  // const inputRefs = useRef({});
  const onInvalid = (errors) => {
    // Find the first key in the errors object
    const firstErrorField = Object.keys(errors)[0];

    if (firstErrorField && inputRefs.current[firstErrorField]) {
      // Get the actual DOM element reference
      const element = inputRefs.current[firstErrorField];

      // Use the browser API to scroll it into view smoothly
      element.scrollIntoView({ behavior: "smooth", block: "center" });

      // Optional: focus the element as well
      element.focus();
    }
  };

  const onSubmit = (formData) => {
    sendEventTobackend("BookNowClicked", null, 1);

    // formData contains: { mobile, email, passengers: [{name, age}, ...] }

    // Merge passenger form values into updatedSeats
    // const mergedSeats = updatedSeats.map((seat, idx) => ({
    //   ...seat,
    //   passangerName: formData.passengers?.[idx]?.passangerName ?? "",
    //   age: formData.passengers?.[idx]?.age ?? "",
    // }));

    console.log(globalData);

    const isLogged = globalData.SignedPassenger.IsPassengerSignedIn;
    const loggedMobileNo =
      globalData.SignedPassenger.SignedPassenger?.MobileNumber;

    console.log(formData);
    // console.log(updatedSeats);

    var deviceId = null;
    var deviceDaySession = null;

    if (window.SessionConstants.DEVICE_INFO_KEY) {
      deviceId = localStorage.getItem(window.SessionConstants.DEVICE_INFO_KEY);
    }

    if (window.SessionConstants.DEVICE_SESSION_KEY) {
      deviceDaySession = JSON.parse(
        localStorage.getItem(window.SessionConstants.DEVICE_SESSION_KEY),
      );
    }

    // if (!isTermsAndConditionsChecked) {
    //   alert("Please Check Terms & Conditions");
    //   return;
    // }

    const mergedSeats = updatedSeats.map((seat, idx) => ({
      SeatName: seat.SeatNumber,
      SeatID: seat.SeatID,
      SeatFare: seat.FARE,
      SeatCUTFare: "0",
      SelectedName: formData.passengers?.[idx]?.passangerName ?? "",
      SelectedGender: seat.gender === true ? 2 : 1,
      SelectedAge: formData.passengers?.[idx]?.age ?? "",
    }));

    const mergedSeatsReturn = updatedSeatsReturn.map((seat, idx) => ({
      SeatName: seat.SeatNumber,
      SeatID: seat.SeatID,
      SeatFare: seat.FARE,
      SeatCUTFare: "0",
      SelectedName: formData.passengersReturn?.[idx]?.passangerName ?? "",
      SelectedGender: seat.gender === true ? 2 : 1,
      SelectedAge: formData.passengersReturn?.[idx]?.age ?? "",
    }));

    //setUpdatedSeats(mergedSeats);

    setContactDetailsOnward({
      mobileOnward: formData.mobileOnward,
      emailOnward: formData.emailOnward,
    });

    setContactDetailsReturn({
      mobileReturn: formData.mobileReturn,
      emailReturn: formData.emailReturn,
    });

    const payload = {
      GATEWAYNumber: 1,
      OnwardBookingDetails: {
        JType: 1,
        JourneyID: currentJourneyId,
        FromCityID: currentFromCityId,
        ToCityID: currentToCityId,
        BoardingPointID: selectedBoarding,
        DropingPointID: selectedDropping,
        ContactNumber: formData.mobileOnward,
        ContactEmail: formData.emailOnward,
        GSTNumber: formData.GSTNumberOnward != undefined ? formData.GSTNumberOnward : "",
        seatsSelected: mergedSeats,
        TRVia: deviceType,
        MISBookingMode: MISBookingModeState,
        RegistrationUniqueID: deviceId || null,
        SessionUniqueID: deviceDaySession?.sessionId || null,
        IsPassengerSignedIn: isLogged,
        SignedPassengerMobileNumber:
          isLogged == 1
            ? loggedMobileNo != null || loggedMobileNo != undefined
              ? loggedMobileNo
              : ""
            : "",
      },
      ReturnBookingDetails: {
        JType: 2,
        JourneyID: currentJourneyIdReturn,
        FromCityID: currentFromCityIdReturn,
        ToCityID: currentToCityIdReturn,
        BoardingPointID: selectedBoardingReturn,
        DropingPointID: selectedDroppingReturn,
        ContactNumber: formData.mobileReturn,
        ContactEmail: formData.emailReturn,
        GSTNumber: formData.GSTNumberReturn != undefined ? formData.GSTNumberReturn : "",
        seatsSelected: mergedSeatsReturn,
        TRVia: deviceType,
        MISBookingMode: MISBookingModeState,
        RegistrationUniqueID: deviceId || null,
        SessionUniqueID: deviceDaySession?.sessionId || null,
        IsPassengerSignedIn: isLogged,
        SignedPassengerMobileNumber:
          isLogged == 1
            ? loggedMobileNo != null || loggedMobileNo != undefined
              ? loggedMobileNo
              : ""
            : "",
      },
    };

    console.log(payload);
    // setFormPayload(payload);
    alert(JSON.stringify(payload));

    var selectors = null;

    if (
      PlatformDetector.isAndroidWebView() ||
      PlatformDetector.isIOSWebView()
    ) {
      selectors = {
        PGSelectionType: 1,
        PGTransactionVia: 1,
        GatewayNumber: 0,
        OrchestratorNumber: 3,
        isFromApp:
          PlatformDetector.isAndroidWebView() || PlatformDetector.isIOSWebView()
            ? 1
            : 0,
      };
    } else {
      selectors = {
        PGSelectionType: 1,
        PGTransactionVia: 1,
        GatewayNumber: 0,
        OrchestratorNumber: 3,
        isFromApp:
          PlatformDetector.isAndroidWebView() || PlatformDetector.isIOSWebView()
            ? 1
            : 0,
      };
    }

    if (selectors != null) {
      setPgselectorUrl(getPgSelectorUrlString(selectors));
    }

    setIsLoading(true);

    axios
      .post(
        `${"/" + paths.BookSeatsTempEndPoint + "?" + getPgSelectorUrlString(selectors)}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        // console.log(res.data);
        let response = res.data;
        if (response.Status) {
          // let res = JSON.parse(response.ResponseData);

          setTimeout(() => {
            //setIsLoading(false);
          }, 2000);

          //alert("... data " + JSON.stringify( response.ResponseData ) );

          const resultantdata = JSON.parse(response.ResponseData);

          // console.log(JSON.parse(response.ResponseData));

          // alert("temp order Id" + resultantdata.TEMPORDERID );
          // console.log(response.ResponseData) B2C/V1/RediretoPG3?TEMPORDERID=;
          window.location.href = `${globalData.ServerBaseUrl + paths.redirectToPg + resultantdata.TEMPORDERID}`;
        } else {
          setIsLoading(false);
          alert(response.Message);
        }
        // if(res.data){
        //   if(res.data.data.Status){
        //       if(res.data.data.ResponseData){
        //         let res = JSON.parse(res.data.data.ResponseData);
        //         console.log(res);
        //       }
        //   }else{
        //     alert(res.data.data.Message);
        //   }
        // }
      })
      .catch((err) => {
        setIsLoading(false);
        alert(err.toString());
        console.log(err);
      });

    // continue to payment
    // handleBookNow(); // or your window.location.replace(paymentUrl)
  };













  return (
    <>
      <Fragment>
        <Dialog
          fullWidth
          open={open}
          onClose={handleClose}
          slots={{
            transition: Transition,
          }}
          PaperProps={{
            sx: {
              m: 0,
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              width: "100vw",
              maxWidth: "100vw",
              height: "90vh",
              maxHeight: "90vh",
              overflowY: "hidden",
            },
          }}
        >
          <AppBar
            sx={{
              padding: "2px 10px",
              position: "relative",
              background: "#F4CC08",
              boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
            }}
          >
            <Toolbar
              sx={{
                background: "#F4CC08",
                display: "flex",
                justifyContent: "space-between",
                gap: "50px",
              }}
            >
              {globalData.onwardJourneyObject && (
                <div
                  style={{
                    background: "#F4CC08",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div>
                    <Typography
                      sx={{
                        color: "#3D18B5",
                        fontWeight: "600",
                        fontSize: "14px",
                      }}
                    >
                      Onward Journey
                    </Typography>

                    <Typography sx={{ color: "#3D18B5", fontWeight: "600" }}>
                      {globalData.onwardJourneyObject?.bus.CoachExternal}
                    </Typography>
                    <Typography sx={{ color: "#3D18B5", fontWeight: "600" }}>
                      {" "}
                      <small>
                        {globalData.onwardJourneyObject?.bus.BoardingCity +
                          "-" +
                          globalData.onwardJourneyObject?.bus.DropCity}
                      </small>{" "}
                    </Typography>
                  </div>

                  <div className="dialog-bus-time-duration">
                    <div className="bus-timings">
                      <span>{globalData.onwardJourneyObject?.bus.MBT}</span>
                      <span>{globalData.onwardJourneyObject?.bus.MDT}</span>
                    </div>
                    <div className="bus-durations">
                      <div className="img-duration-content">
                        <span className="duration">
                          {" "}
                          {globalData.onwardJourneyObject?.bus
                            ? globalData.onwardJourneyObject?.bus.Duration
                            : ""}{" "}
                        </span>
                        <img src="/images/line_with_circle_purple.svg" />
                      </div>
                    </div>
                  </div>

                  <div style={{ display: "flex", gap: "50px" }}>
                    <div className="bus-date-time">
                      {globalData.isReturnJourneyExist ? (
                        <>
                          <span>{onwardDateFormatWithMonthName}</span>
                          <span>{onwardDayName}</span>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {globalData.returnJourneyObject && (
                <div
                  style={{
                    background: "#F4CC08",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    borderLeft: "1px solid #3D18B5",
                    paddingLeft: "10px",
                  }}
                >
                  <div>
                    <Typography
                      sx={{
                        color: "#3D18B5",
                        fontWeight: "600",
                        fontSize: "14px",
                      }}
                    >
                      Return Journey
                    </Typography>

                    <Typography sx={{ color: "#3D18B5", fontWeight: "600" }}>
                      {globalData.returnJourneyObject?.bus.CoachExternal}
                    </Typography>
                    <Typography sx={{ color: "#3D18B5", fontWeight: "600" }}>
                      {" "}
                      <small>
                        {globalData.returnJourneyObject?.bus.BoardingCity +
                          "-" +
                          globalData.returnJourneyObject?.bus.DropCity}
                      </small>{" "}
                    </Typography>
                  </div>

                  <div className="dialog-bus-time-duration">
                    <div className="bus-timings">
                      <span>{globalData.returnJourneyObject?.bus.MBT}</span>
                      <span>{globalData.returnJourneyObject?.bus.MDT}</span>
                    </div>
                    <div className="bus-durations">
                      <div className="img-duration-content">
                        <span className="duration">
                          {" "}
                          {globalData.returnJourneyObject?.bus
                            ? globalData.returnJourneyObject?.bus.Duration
                            : ""}{" "}
                        </span>
                        <img src="/images/line_with_circle_purple.svg" />
                      </div>
                    </div>
                  </div>

                  <div style={{ display: "flex", gap: "50px" }}>
                    <div className="bus-date-time">
                      {globalData.isReturnJourneyExist ? (
                        <>
                          <span>{returnDateFormatWithMonthName}</span>
                          <span>{returnDayName}</span>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              )}

              <IconButton
                edge="start"
                onClick={handleClose}
                aria-label="close"
                sx={{
                  color: "#2D3FA8",
                  border: "1px solid #2D3FA8",
                  borderRadius: "50%",
                  "&:hover": {
                    color: "#fff",
                    backgroundColor: "#2D3FA8",
                  },
                  height: "30px",
                  width: "30px",
                }}
              >
                <IoMdClose />
              </IconButton>
            </Toolbar>
          </AppBar>
          <box
            sx={{
              borderBottom: 1,
              borderColor: "#2D3FA8",
              borderWidth: "2px",
              padding: 0,
              marginTop: "-2px",
              height: "35px",
              maxHeight: "35px",
            }}
          >
            <Tabs
              value={tabMainValue}
              onChange={handleTabMainChange}
              centered={true}
              sx={tabsStyle}
              TabIndicatorProps={{ style: { display: "none" } }}
              aria-label="basic tabs example"
            >
              <Tab label="Onward Journey" />
              <Tab label="Return Journey" />
              <Tab label="Passanger Information" />
            </Tabs>
          </box>

          <DialogContent
            ref={dialogContentRef}
          >
            <CustomTabPanel value={tabMainValue} index={0}>
              <box>
                <Tabs
                  value={tabValue}
                  onChange={handleOnwardTabChange}
                  centered={true}
                  sx={tabsStyle}
                  TabIndicatorProps={{ style: { display: "none" } }}
                >
                  <Tab sx={tabstyles} label="View Seats" />
                  <Tab sx={tabstyles} label="Boarding / Dropping Point" />
                  <Tab sx={tabstyles} label="Bus Route" />
                  <Tab sx={tabstyles} label="About Bus" />
                </Tabs>
              </box>
              <box>
                <CustomJourneyOnwardTabPanel value={tabValue} index={0}>
                  {isLayoutDataLoading ? (
                    <SeatLayoutHorizontalSkeleton />
                  ) : (
                    <div className="seat-layout-content">
                      <div>
                        <div
                          className={
                            layoutOrientation == 1
                              ? "seat-layout"
                              : "seat-layout-vertical"
                          }
                        >
                          {/* <div>{parsedData && parsedData}</div> */}
                          {layoutsList && layoutsList.length > 0 ? (
                            <>
                              {layoutsList.map((layoutItem, index) => (
                                <div
                                  key={index}
                                  style={{ marginTop: "20px" }}
                                  className={
                                    layoutOrientation == 1
                                      ? "layout-deck-content"
                                      : "layout-deck-content-vertical"
                                  }
                                >
                                  <div className="busfront">
                                    <div className="driver-seat">
                                      {layoutItem.DeckName === "Lower Deck" ? (
                                        <GiSteeringWheel
                                          size={20}
                                          className="steering-icon"
                                        />
                                      ) : (
                                        <i style={{ paddingLeft: "16px" }}>
                                          &nbsp;
                                        </i>
                                      )}
                                    </div>
                                    <div className="deck-name">
                                      {layoutItem.DeckName}
                                    </div>
                                  </div>
                                  <div>
                                    {layoutItem.parsedData &&
                                      layoutItem.parsedData}
                                  </div>
                                </div>
                              ))}
                            </>
                          ) : (
                            <>
                              {globalData.onwardJourneyObject != null ? (
                                <>
                                  <div className="unselected">
                                    <span>
                                      {" "}
                                      Some Thing Went Wrong ! unable display
                                      Return Journey Layout{" "}
                                    </span>
                                  </div>
                                </>
                              ) : (
                                <div className="unselected">
                                  <span
                                    onClick={() => {
                                      handleTabChangeInDialog("1");
                                    }}
                                  >
                                    {" "}
                                    Please Click Here to Select a Onward Journey
                                    From Search{" "}
                                  </span>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>

                      <div className="seat-info">
                        <div className="seat-layout-seat-info">
                          <div className="seat-items-info-large">
                            <span> Available </span>
                            <div>
                              <div className="seat-info-empty-seat-large">
                                <div className="slot"></div>
                              </div>
                            </div>
                          </div>

                          <div className="seat-items-info-large">
                            <span> Selected </span>
                            <div>
                              <div className="seat-info-empty-seat-large selected-seat">
                                <div className="slot"></div>
                              </div>
                            </div>
                          </div>

                          <div className="seat-items-info-large">
                            <span> Booked </span>
                            <div>
                              <div className="seat-info-empty-seat-large booked-seat">
                                <div className="slot"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </CustomJourneyOnwardTabPanel>
                {/* end of onward  */}
                <CustomJourneyOnwardTabPanel value={tabValue} index={1}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignContent: "center",
                    }}
                  >
                    {globalData.onwardJourneyObject == null ? (
                      <>
                        <div className="unselected">
                          <span
                            onClick={() => {
                              handleTabChangeInDialog("1");
                            }}
                          >
                            {" "}
                            Please Click Here to Select a Onward Journey From
                            Search{" "}
                          </span>
                        </div>
                      </>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "20px",
                        }}
                      >
                        <div className="dialog-board-drop-container">
                          <div className="dialog-boarding-points">
                            <h3 className="headings-main">
                              Select Boarding Point
                            </h3>
                            <small></small>

                            {pickupPoints &&
                              pickupPoints.map((item, index) => (
                                <div className="dialog-input-containers">
                                  <div className="dialog-input-radio">
                                    <div className="inputs-content">
                                      <label
                                        className="radio-label"
                                        key={item.BoardingPointID + "-" + index}
                                      >
                                        <div>
                                          <input
                                            type="radio"
                                            name="boardings"
                                            value={item.BoardingPointID}
                                            id={
                                              item.BoardingPointID + "-" + index
                                            }
                                            checked={
                                              selectedBoarding ===
                                              item.BoardingPointID
                                            }
                                            onChange={handleBoardingPointChange}
                                          />
                                          <span> {item.DepartureTime}</span>
                                        </div>

                                        <span className="pointname">
                                          {item.PointName}
                                        </span>
                                      </label>
                                    </div>

                                    <div className="br-details" onClick={() => handleBoardingPointChange({ target: { value: item.BoardingPointID } })}  >
                                      <div className="left-content-br">
                                        <div className="content-bottom">
                                          {/* {item.ContactMobileNumber != "" ? (
                                            <div className="mobile-number">
                                              <a
                                                href={
                                                  "tel:" +
                                                  item.ContactMobileNumber
                                                }
                                              >
                                                <CiPhone />{" "}
                                                <>
                                                  {
                                                    item.ContactMobileNumber
                                                  }{" "}
                                                </>{" "}
                                              </a>{" "}
                                              &nbsp;
                                            </div>
                                          ) : (
                                            ""
                                          )} */}
                                         

                                          <div className="icons-container">
                                            <a className="location-button" onClick={(e)=>{e.stopPropagation();}}  target="_blank" href={'/show-pickup-dropping?lat=15.350417344847436&lon=75.1391945019891'}>
                                              <CiLocationOn />
                                            </a>

                                            {/* <span className="location-button">
                                              <TbView360Number />
                                            </span> */}
                                          </div>
                                            <ContactPhone mobileNumber={item.ContactMobileNumber} />
                                        </div>
                                      </div>

                                      <div className="right-content-br">
                                        <span>
                                          {item.LandMark1 !== ""
                                            ? item.LandMark1
                                            : ""}
                                        </span>
                                        <span>
                                          {item.LandMark2 !== ""
                                            ? item.LandMark2
                                            : ""}
                                        </span>
                                        <span>
                                          {item.AddressLine1 !== ""
                                            ? item.AddressLine1
                                            : ""}
                                        </span>
                                        <span>
                                          {item.AddressLine2 !== ""
                                            ? item.AddressLine2
                                            : ""}
                                        </span>
                                        <span>
                                          {item.AddressLine3 !== ""
                                            ? item.AddressLine3
                                            : ""}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>

                          <div className="dialog-dropping-points">
                            <h3 className="headings-main">
                              Select Dropping Points
                            </h3>
                            <small></small>
                            {droppingPoints &&
                              droppingPoints.map((item, index) => (
                                <div className="dialog-input-containers">
                                  <div className="dialog-input-radio">
                                    <div className="inputs-content-dropping">
                                      <label
                                        className="radio-label"
                                        key={
                                          item.BoardingPointID +
                                          "-" +
                                          index +
                                          "dropping"
                                        }
                                      >
                                        <span className="pointname">
                                          {item.PointName}
                                        </span>

                                        <div>
                                          <span> {item.ArrivalTime}</span>
                                          <input
                                            type="radio"
                                            name="droppings"
                                            value={item.BoardingPointID}
                                            id={
                                              item.BoardingPointID + "-" + index
                                            }
                                            checked={
                                              selectedDropping ===
                                              item.BoardingPointID
                                            }
                                            onChange={handleDroppingPointChange}
                                          />
                                        </div>
                                      </label>
                                    </div>

                                    <div className="dr-details" onClick={() => handleDroppingPointChange({ target: { value: item.BoardingPointID } })}>
                                      

                                      <div className="right-content-br">
                                        <span>
                                          {item.LandMark1 !== ""
                                            ? item.LandMark1
                                            : ""}
                                        </span>
                                        <span>
                                          {item.LandMark2 !== ""
                                            ? item.LandMark2
                                            : ""}
                                        </span>
                                        <span>
                                          {item.AddressLine1 !== ""
                                            ? item.AddressLine1
                                            : ""}
                                        </span>
                                        <span>
                                          {item.AddressLine2 !== ""
                                            ? item.AddressLine2
                                            : ""}
                                        </span>
                                        <span>
                                          {item.AddressLine3 !== ""
                                            ? item.AddressLine3
                                            : ""}
                                        </span>
                                      </div>


                                      <div className="left-content-br">
                                        <div className="content-bottom">
                                          <ContactPhone mobileNumber={item.ContactMobileNumber} />
                                          <div className="icons-container">
                                            <a className="location-button" onClick={(e)=>{e.stopPropagation();}}  target="_blank" href={'/show-pickup-dropping?lat=15.350417344847436&lon=75.1391945019891'}>
                                              <CiLocationOn />
                                            </a>

                                            {/* <span className="location-button">
                                              <TbView360Number />
                                            </span> */}
                                          </div>

                                          {/* {item.ContactMobileNumber != "" ? (
                                            <div className="mobile-number">
                                              <a
                                                href={
                                                  "tel:" +
                                                  item.ContactMobileNumber
                                                }
                                              >
                                                <CiPhone />{" "}
                                                <>
                                                  {
                                                    item.ContactMobileNumber
                                                  }{" "}
                                                </>{" "}
                                              </a>{" "}
                                              &nbsp;
                                            </div>
                                          ) : (
                                            ""
                                          )} */}
                                        </div>
                                      </div>


                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </CustomJourneyOnwardTabPanel>

                {/* End of the onward Boarding / dropiing Points  */}
              </box>
            </CustomTabPanel>

            <CustomTabPanel value={tabMainValue} index={1}>
              <box>
                <Tabs
                  value={returnTabValue}
                  onChange={handleReturnTabChange}
                  centered={true}
                  sx={tabsStyle}
                  TabIndicatorProps={{ style: { display: "none" } }}
                >
                  <Tab sx={tabstyles} label="View Seats" />
                  <Tab sx={tabstyles} label="Boarding / Dropping Point" />
                  <Tab sx={tabstyles} label="Bus Route" />
                  <Tab sx={tabstyles} label="About Bus" />
                </Tabs>
              </box>

              <box>
                <CustomJourneyReturnTabPanel value={returnTabValue} index={0}>
                  {isLayoutDataLoadingReturn ? (
                    <SeatLayoutHorizontalSkeleton />
                  ) : (
                    <div className="seat-layout-content">
                      <div>
                        <div
                          className={
                            layoutOrientation == 1
                              ? "seat-layout"
                              : "seat-layout-vertical"
                          }
                        >
                          {/* <div>{parsedData && parsedData}</div> */}

                          {layoutsListReturn && layoutsListReturn.length > 0 ? (
                            <>
                             
                              {layoutsListReturn.map((layoutItem, index) => (
                                <div
                                  key={index}
                                  style={{ marginTop: "20px" }}
                                  className={
                                    layoutOrientation == 1
                                      ? "layout-deck-content"
                                      : "layout-deck-content-vertical"
                                  }
                                >
                                  <div className="busfront">
                                    <div className="driver-seat">
                                      {layoutItem.DeckName === "Lower Deck" ? (
                                        <GiSteeringWheel
                                          size={20}
                                          className="steering-icon"
                                        />
                                      ) : (
                                        <i style={{ paddingLeft: "16px" }}>
                                          &nbsp;
                                        </i>
                                      )}
                                    </div>
                                    <div className="deck-name">
                                      {layoutItem.DeckName}
                                    </div>
                                  </div>
                                  <div>
                                    {layoutItem.parsedData &&
                                      layoutItem.parsedData}
                                  </div>
                                </div>
                              ))}
                            </>
                          ) : (
                            <>
                              {globalData.returnJourneyObject != null ? (
                                <>
                                  <div className="unselected">
                                    <span>                                      
                                      Some Thing Went Wrong ! unable display
                                      Return Journey Layout
                                    </span>
                                  </div>
                                </>
                              ) : (
                                <div className="unselected">
                                  <span
                                    onClick={() => {
                                      handleTabChangeInDialog("2");
                                    }}
                                  >                                    
                                    Please Click Here to Select a Return Journey
                                    From Search
                                  </span>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>

                      <div className="seat-info">
                        <div className="seat-layout-seat-info">
                          <div className="seat-items-info-large">
                            <span> Available </span>
                            <div>
                              <div className="seat-info-empty-seat-large">
                                <div className="slot"></div>
                              </div>
                            </div>
                          </div>

                          <div className="seat-items-info-large">
                            <span> Selected </span>
                            <div>
                              <div className="seat-info-empty-seat-large selected-seat">
                                <div className="slot"></div>
                              </div>
                            </div>
                          </div>

                          <div className="seat-items-info-large">
                            <span> Booked </span>
                            <div>
                              <div className="seat-info-empty-seat-large booked-seat">
                                <div className="slot"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </CustomJourneyReturnTabPanel>
                {/* end of return journey view seats */}
                <CustomJourneyReturnTabPanel value={returnTabValue} index={1}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignContent: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <div className="dialog-board-drop-container">
                        {globalData.returnJourneyObject == null ? (
                          <>
                            <div className="unselected">
                              <span
                                onClick={() => {
                                  handleTabChangeInDialog("2");
                                }}
                              >
                                {" "}
                                Please Click Here to Select a Return Journey
                                From Search{" "}
                              </span>
                            </div>
                          </>
                        ) :

                        <>                     

                        <div className="dialog-boarding-points">
                          <h3 className="headings-main">
                            Select Boarding Point
                          </h3>
                          <small></small>

                          {pickupPointsReturn &&
                            pickupPointsReturn.map((item, index) => (
                              <div className="dialog-input-containers">
                                <div className="dialog-input-radio">
                                  <div className="inputs-content">
                                    <label
                                      className="radio-label"
                                      key={item.BoardingPointID + "-" + index}
                                    >
                                      <div>
                                        <input
                                          type="radio"
                                          name="boardingsReturn"
                                          value={item.BoardingPointID}
                                          id={
                                            item.BoardingPointID +
                                            "-" +
                                            index +
                                            "return"
                                          }
                                          checked={
                                            selectedBoardingReturn ===
                                            item.BoardingPointID
                                          }
                                          onChange={
                                            handleBoardingPointChangeReturn
                                          }
                                        />
                                        <span> {item.DepartureTime}</span>
                                      </div>

                                      <span className="pointname">
                                        {item.PointName}
                                      </span>
                                    </label>
                                  </div>

                                  <div className="br-details" onClick={() => handleBoardingPointChangeReturn({ target: { value: item.BoardingPointID } })}>
                                    <div className="left-content-br">
                                      <div className="content-bottom">
                                        {/* {item.ContactMobileNumber != "" ? (
                                          <div className="mobile-number">
                                            <a
                                              href={
                                                "tel:" +
                                                item.ContactMobileNumber
                                              }
                                            >
                                              <CiPhone />{" "}
                                              <>
                                                {item.ContactMobileNumber}{" "}
                                              </>{" "}
                                            </a>{" "}
                                            &nbsp;
                                          </div>
                                        ) : (
                                          ""
                                        )} */}

                                        <ContactPhone mobileNumber={item.ContactMobileNumber} />

                                        <div className="icons-container">
                                          <a className="location-button" onClick={(e)=>{e.stopPropagation();}}  target="_blank" href={'/show-pickup-dropping?lat=15.350417344847436&lon=75.1391945019891'}>
                                            <CiLocationOn />
                                          </a>

                                          {/* <span className="location-button">
                                            <TbView360Number />
                                          </span> */}
                                        </div>
                                      </div>
                                    </div>

                                    <div className="right-content-br">
                                      <span>
                                        {item.LandMark1 !== ""
                                          ? item.LandMark1
                                          : ""}
                                      </span>
                                      <span>
                                        {item.LandMark2 !== ""
                                          ? item.LandMark2
                                          : ""}
                                      </span>
                                      <span>
                                        {item.AddressLine1 !== ""
                                          ? item.AddressLine1
                                          : ""}
                                      </span>
                                      <span>
                                        {item.AddressLine2 !== ""
                                          ? item.AddressLine2
                                          : ""}
                                      </span>
                                      <span>
                                        {item.AddressLine3 !== ""
                                          ? item.AddressLine3
                                          : ""}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>

                        <div className="dialog-dropping-points">
                          <h3 className="headings-main">
                            Select Dropping Points
                          </h3>
                          <small></small>
                          {droppingPointsReturn &&
                            droppingPointsReturn.map((item, index) => (
                              <div className="dialog-input-containers">
                                <div className="dialog-input-radio">
                                  <div className="inputs-content-dropping">
                                    <label
                                      className="radio-label"
                                      key={
                                        item.BoardingPointID +
                                        "-" +
                                        index +
                                        "dropping"
                                      }
                                    >
                                      <span className="pointname">
                                        {item.PointName}
                                      </span>

                                      <div>
                                        <span> {item.ArrivalTime}</span>
                                        <input
                                          type="radio"
                                          name="droppingsReturn"
                                          value={item.BoardingPointID}
                                          id={
                                            item.BoardingPointID +
                                            "-" +
                                            index +
                                            "return"
                                          }
                                          checked={
                                            selectedDroppingReturn ===
                                            item.BoardingPointID
                                          }
                                          onChange={
                                            handleDroppingPointChangeReturn
                                          }
                                        />
                                      </div>
                                    </label>
                                  </div>

                                  <div className="dr-details" onClick={() => handleDroppingPointChangeReturn({ target: { value: item.BoardingPointID } })}>
                                   

                                    <div className="right-content-br">
                                      <span>
                                        {item.LandMark1 !== ""
                                          ? item.LandMark1
                                          : ""}
                                      </span>
                                      <span>
                                        {item.LandMark2 !== ""
                                          ? item.LandMark2
                                          : ""}
                                      </span>
                                      <span>
                                        {item.AddressLine1 !== ""
                                          ? item.AddressLine1
                                          : ""}
                                      </span>
                                      <span>
                                        {item.AddressLine2 !== ""
                                          ? item.AddressLine2
                                          : ""}
                                      </span>
                                      <span>
                                        {item.AddressLine3 !== ""
                                          ? item.AddressLine3
                                          : ""}
                                      </span>
                                    </div>

                                     <div className="left-content-br">
                                      <div className="content-bottom">

                                       <ContactPhone mobileNumber={item.ContactMobileNumber} />
                                        
                                        <div className="icons-container">
                                          <a className="location-button" onClick={(e)=>{e.stopPropagation();}}  target="_blank" href={'/show-pickup-dropping?lat=15.350417344847436&lon=75.1391945019891'}>
                                            <CiLocationOn />
                                          </a>

                                          {/* <span className="location-button">
                                            <TbView360Number />
                                          </span> */}
                                        </div>

                                        {/* {item.ContactMobileNumber != "" ? (
                                          <div className="mobile-number">
                                            <a
                                              href={
                                                "tel:" +
                                                item.ContactMobileNumber
                                              }
                                            >
                                              <CiPhone />{" "}
                                              <>
                                                {item.ContactMobileNumber}{" "}
                                              </>{" "}
                                            </a>{" "}
                                            &nbsp;
                                          </div>
                                        ) : (
                                          ""
                                        )} */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                        </>
                        }
                      </div>
                    </div>
                  </div>
                </CustomJourneyReturnTabPanel>
              </box>
            </CustomTabPanel>

            <CustomTabPanel value={tabMainValue} index={2}>
              <>
                <div className="passanger-detiales-content">
                  {selectedSeats?.length > 0 &&
                  selectedBoarding?.length > 0 &&
                  selectedDropping?.length > 0 &&
                  selectedSeatsReturn?.length > 0 &&
                  selectedBoardingReturn?.length > 0 &&
                  selectedDroppingReturn?.length > 0 ? (
                    <>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <div style={{ maxWidth: "1600px" }}>
                          <div className="customer-info-table-content">
                            <div className="contact-details">
                              <h3 className="headings-main">Contact Details</h3>
                              <div className="divider"></div>
                              <div className="contact-details-card">
                                <div className="contact-details-form">
                                  <div style={{ width: "100%" }}>
                                    <Controller
                                      name="mobileOnward"
                                      control={control}
                                      rules={{
                                        required: "Mobile number is required",
                                        pattern: {
                                          value: /^[0-9]{10}$/,
                                          message:
                                            "Enter a valid 10-digit mobile number",
                                        },
                                      }}
                                      render={({ field }) => (
                                        <TextField
                                          {...field}
                                          // Capture the ref into our manual inputRefs map
                                          inputRef={(el) => {
                                            field.ref(el); // Still let RHF manage its own ref internally
                                            inputRefs.current.mobileOnward = el; // Manually track it for our scroll logic
                                          }}
                                          onBlur={(e) => {
                                            field.onBlur();
                                            const value = e.target.value;
                                            sendEventTobackend(
                                              "ContactMobileNoTouched",
                                              null,
                                              1,
                                            );
                                          }}
                                          placeholder="Mobile Number *"
                                          variant="outlined"
                                          size="small"
                                          fullWidth
                                          error={!!errors.mobileOnward}
                                          helperText={
                                            errors.mobileOnward?.message
                                          }
                                          inputProps={{
                                            maxLength: 10,
                                            autoComplete: "none",
                                          }}
                                          sx={{
                                            "& .MuiInputLabel-root": {
                                              fontSize: "13px",
                                              "&.Mui-focused": {
                                                color: "#2D3FA8",
                                              },
                                            },

                                            "& .MuiOutlinedInput-root": {
                                              maxHeight: "30px",

                                              "& .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },

                                              "&:hover .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "",
                                                },

                                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },
                                            },

                                            "& label.Mui-focused": {
                                              color: "#1F1F1F",
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </div>
                                  <div style={{ width: "100%" }}>
                                    <Controller
                                      name="emailOnward"
                                      control={control}
                                      rules={{
                                        required: "Email is required",
                                        pattern: {
                                          value:
                                            /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i,
                                          message:
                                            "Enter a valid email address",
                                        },
                                      }}
                                      render={({ field }) => (
                                        <TextField
                                          {...field}
                                          inputRef={(el) => {
                                            field.ref(el); // Still let RHF manage its own ref internally
                                            inputRefs.current.emailOnward = el; // Manually track it for our scroll logic
                                          }}
                                          onBlur={(e) => {
                                            field.onBlur();
                                            const value = e.target.value;
                                            sendEventTobackend(
                                              "ContactEmailTouched",
                                              null,
                                              1,
                                            );
                                          }}
                                          placeholder="E-mail *"
                                          variant="outlined"
                                          size="small"
                                          fullWidth
                                          error={!!errors.emailOnward}
                                          helperText={
                                            errors.emailOnward?.message
                                          }
                                          inputProps={{ autoComplete: "none" }}
                                          sx={{
                                            "& .MuiInputLabel-root": {
                                              fontSize: "13px",
                                              "&.Mui-focused": {
                                                color: "#2D3FA8",
                                              },
                                            },

                                            "& .MuiOutlinedInput-root": {
                                              maxHeight: "30px",

                                              "& .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },

                                              "&:hover .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "",
                                                },

                                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },
                                            },

                                            "& label.Mui-focused": {
                                              color: "#1F1F1F",
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </div>
                                   <div style={{ width: "100%" }}>
                                                                  <Controller
                                                                    name="GSTNumberOnward"
                                                                    control={control}
                                                                    rules={{
                                                                      pattern: {
                                                                       value: /^[a-zA-Z0-9]{15}$/, 
                                                                      //  exact gst pattern match
                                                                      //  /^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1}$/
                                                                        message:
                                                                          "Enter a valid 15-digit GST number",
                                                                      },
                                                                    }}
                                                                    render={({ field }) => (
                                                                      <TextField
                                                                        {...field}
                                                                        // Capture the ref into our manual inputRefs map
                                                                        inputRef={(el) => {
                                                                          field.ref(el); // Still let RHF manage its own ref internally
                                                                          inputRefs.current.GSTNumberOnward = el; // Manually track it for our scroll logic
                                                                        }}
                                                                        onBlur={(e)=>{
                                                                          field.onBlur();
                                                                          const value = e.target.value;
                                                                          sendEventTobackend("ContactGSTNumberTouched",null,1) 
                                                                        }}
                                                                                                              placeholder="GST Number"
                                                                        variant="outlined"
                                                                        size="small"
                                                                        fullWidth
                                                                        error={!!errors.GSTNumberOnward}
                                                                        helperText={errors.GSTNumberOnward?.message}
                                                                        inputProps={{
                                                                          maxLength: 15 ,
                                                                          autoComplete: "none",
                                                                        }}
                                                                        sx={{
                                                                          "& .MuiInputLabel-root": {
                                                                            fontSize: "13px",
                                                                            "&.Mui-focused": {
                                                                              color: "#2D3FA8",
                                                                            },
                                                                          },
                                  
                                                                          "& .MuiOutlinedInput-root": {
                                                                            maxHeight: "30px",
                                  
                                                                            "& .MuiOutlinedInput-notchedOutline":
                                                                              {
                                                                                borderColor: "#2D3FA8",
                                                                                borderWidth: "1px",
                                                                              },
                                  
                                                                            "&:hover .MuiOutlinedInput-notchedOutline":
                                                                              {
                                                                                borderColor: "",
                                                                              },
                                  
                                                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                                              {
                                                                                borderColor: "#2D3FA8",
                                                                                borderWidth: "1px",
                                                                              },
                                                                          },
                                  
                                                                          "& label.Mui-focused": {
                                                                            color: "#1F1F1F",
                                                                          },
                                                                        }}
                                                                      />
                                                                    )}
                                                                  />
                                   </div>
                                </div>
                                <small
                                  style={{
                                    color: "#2D3FA8",
                                    paddingLeft: "0px",
                                  }}
                                >
                                  Journey & Ticket Details will be sent these
                                  details!
                                </small>
                              </div>
                            </div>
                          </div>

                          {/* onward Journey  passanger information*/}

                          <div className="passenger-details">
                            <h3 className="headings-main">
                              Onward Journey Passanger Details
                            </h3>
                            <div className="divider"></div>

                            <div className="table-header">
                              <div className="column-title"> Sl. No </div>
                              <div className="column-title"> Seat </div>
                              <div className="column-title"> Name </div>
                              <div className="column-title"> Age </div>
                              <div className="column-title"> Gender </div>
                              <div className="column-title price"> Price </div>
                            </div>

                            <div className="table-body">
                              {/* map over updatedSeats to render one row per passenger and wire to form passengers[index] */}
                              {updatedSeats?.map((item, index) => (
                                <div
                                  className="filed-row"
                                  key={item.SeatID ?? index}
                                >
                                  <div className="field"> {index + 1} </div>
                                  <div className="field">
                                    {" "}
                                    {item.SeatNumber}{" "}
                                  </div>

                                  {/* PASSENGER NAME */}
                                  <div className="field">
                                    <Controller
                                      name={`passengers.${index}.passangerName`}
                                      control={control}
                                      rules={{
                                        required: "Name is required",
                                        pattern: {
                                          value: /^[a-zA-Z ]*$/,
                                          message: "Enter valid Name",
                                        },
                                        minLength: {
                                          value: 2,
                                          message: "Enter a valid name",
                                        },
                                      }}
                                      render={({ field }) => (
                                        <TextField
                                          {...field}
                                          inputRef={(el) => {
                                            field.ref(el); // Still let RHF manage its own ref internally
                                            inputRefs.current.passangerName =
                                              el; // Manually track it for our scroll logic
                                          }}
                                          placeholder="Passenger Name *"
                                          variant="outlined"
                                          size="small"
                                          inputProps={{ autoComplete: "none" }}
                                          onChange={(e) => {
                                            field.onChange(e); // update react-hook-form
                                            const newSeats = [...updatedSeats];
                                            if (newSeats[index]) {
                                              newSeats[index].passangerName =
                                                e.target.value;
                                              setUpdatedSeats(newSeats); // sync with updatedSeats
                                            }
                                          }}
                                          onBlur={(e) => {
                                            field.onBlur();
                                            const value = e.target.value;
                                            sendEventTobackend(
                                              "PassengerNameTouched",
                                              null,
                                              1,
                                            );
                                          }}
                                          error={
                                            !!(
                                              errors.passengers &&
                                              errors.passengers[index]
                                                ?.passangerName
                                            )
                                          }
                                          helperText={
                                            errors.passengers &&
                                            errors.passengers[index]
                                              ?.passangerName?.message
                                          }
                                          fullWidth
                                          sx={{
                                            "& .MuiInputLabel-root": {
                                              fontSize: "13px",
                                              "&.Mui-focused": {
                                                color: "#2D3FA8",
                                              },
                                            },

                                            "& .MuiOutlinedInput-root": {
                                              maxHeight: "30px",

                                              "& .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },

                                              "&:hover .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "",
                                                },

                                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },
                                            },

                                            "& label.Mui-focused": {
                                              color: "#1F1F1F",
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </div>

                                  {/* PASSENGER AGE */}
                                  <div className="field">
                                    <Controller
                                      name={`passengers.${index}.age`}
                                      control={control}
                                      rules={{
                                        required: "Age is required",
                                        pattern: {
                                          value: /^[0-9]{1,3}$/,
                                          message: "Enter valid age",
                                        },
                                        validate: (v) =>
                                          (Number(v) > 0 && Number(v) < 130) ||
                                          "Enter valid age",
                                      }}
                                      render={({ field }) => (
                                        <TextField
                                          {...field}
                                          inputRef={(el) => {
                                            field.ref(el); // Still let RHF manage its own ref internally
                                            inputRefs.current.age = el; // Manually track it for our scroll logic
                                          }}
                                          placeholder="Age *"
                                          variant="outlined"
                                          size="small"
                                          error={
                                            !!(
                                              errors.passengers &&
                                              errors.passengers[index]?.age
                                            )
                                          }
                                          helperText={
                                            errors.passengers &&
                                            errors.passengers[index]?.age
                                              ?.message
                                          }
                                          inputProps={{
                                            inputMode: "numeric",
                                            pattern: "[0-9]*",
                                            maxLength: 3,
                                            autoComplete: "none",
                                          }}
                                          onChange={(e) => {
                                            field.onChange(e); // update react-hook-form
                                            const newSeats = [...updatedSeats];
                                            if (newSeats[index]) {
                                              newSeats[index].age =
                                                e.target.value;
                                              setUpdatedSeats(newSeats); // sync with updatedSeats
                                            }
                                          }}
                                          onBlur={(e) => {
                                            field.onBlur();
                                            const value = e.target.value;
                                            sendEventTobackend(
                                              "PassengerAgeTouched",
                                              null,
                                              1,
                                            );
                                          }}
                                          fullWidth
                                          sx={{
                                            "& .MuiInputLabel-root": {
                                              fontSize: "13px",
                                              "&.Mui-focused": {
                                                color: "#2D3FA8",
                                              },
                                            },

                                            "& .MuiOutlinedInput-root": {
                                              maxHeight: "30px",

                                              "& .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },

                                              "&:hover .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "",
                                                },

                                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },
                                            },

                                            "& label.Mui-focused": {
                                              color: "#1F1F1F",
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </div>

                                  {/* GENDER (keeps your current UI + handlers) */}
                                  <div className="gender">
                                    <div
                                      className="gender-switch-container"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          color: "#3D18B5",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          handleMaleIconClick(item.SeatNumber)
                                        }
                                      >
                                        <img
                                          src="/images/MaleTransparent_1.png"
                                          style={{
                                            width: "34px",
                                            height: "34px",
                                            borderRadius: "4px",
                                          }}
                                        />
                                      </span>

                                      <FormControlLabel
                                        control={
                                          <Switch
                                            checked={item.gender}
                                            onChange={() =>
                                              handleGenderChange(
                                                item.SeatNumber,
                                              )
                                            }
                                            sx={{
                                              "& .MuiSwitch-thumb": {
                                                backgroundColor: item.gender
                                                  ? "#ff1493"
                                                  : "#2D3FA8",
                                              },
                                              "& .MuiSwitch-track": {
                                                backgroundColor: "#F4CC13",
                                                opacity: 0.4,
                                              },
                                            }}
                                          />
                                        }
                                      />

                                      <span
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          handleFeMaleIconClick(item.SeatNumber)
                                        }
                                      >
                                        <img
                                          src="/images/femaleTransparent1.png"
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "4px",
                                          }}
                                        />
                                      </span>
                                    </div>
                                  </div>

                                  <div className="field price">
                                    &#8377; {item.FARE}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>

                          <div className="br-dr-container">
                            <div className="passenger-card-container-small">
                              <div className="card-top-button-br-dr">
                                Boarding Point
                              </div>
                              <div className="passenger-card-small">
                                <div className="boarding-dropping-info">
                                  <div>
                                    <div className="points">
                                      <div className="left">
                                        <span className="pointname">
                                          {" "}
                                          {selectedBoardingName
                                            ? selectedBoardingName.PointName
                                            : ""}{" "}
                                        </span>
                                      </div>
                                      <div className="right">
                                        <span className="pointname">
                                          {" "}
                                          {selectedBoardingName
                                            ? selectedBoardingName.DepartureTime
                                            : ""}{" "}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="dr-details"  >
                                      

                                      <div className="right-content-br">
                                        <span>
                                          {selectedBoardingName?.AddressLine2
                                            .LandMark1 !== ""
                                            ? selectedBoardingName?.LandMark1
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedBoardingName?.LandMark2 !==
                                          ""
                                            ? selectedBoardingName?.LandMark2
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedBoardingName?.AddressLine1 !==
                                          ""
                                            ? selectedBoardingName?.AddressLine1
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedBoardingName?.AddressLine2 !==
                                          ""
                                            ? selectedBoardingName?.AddressLine2
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedBoardingName?.AddressLine3 !==
                                          ""
                                            ? selectedBoardingName?.AddressLine3
                                            : ""}
                                        </span>
                                      </div>

                                           
                                      <div className="left-content-br">
                                        <div className="content-bottom">
                                          <ContactPhone mobileNumber={selectedBoardingName.ContactMobileNumber} /> 
                                          <div className="icons-container">
                                            <a className="location-button" onClick={(e)=>{e.stopPropagation();}}  target="_blank" href={'/show-pickup-dropping?lat=15.350417344847436&lon=75.1391945019891'}>
                                              <CiLocationOn />
                                            </a>

                                            {/* <span className="location-button">
                                              <TbView360Number />
                                            </span> */}
                                          </div>

                                          
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="passenger-card-container-small">
                              <div className="card-top-button-br-dr">
                                Dropping Point
                              </div>
                              <div className="passenger-card-small">
                                <div className="boarding-dropping-info">
                                  <div>
                                    <div className="points">
                                      <div className="left">
                                        <span className="pointname">
                                          {" "}
                                          {selectedDroppingName
                                            ? selectedDroppingName.PointName
                                            : ""}{" "}
                                        </span>
                                      </div>
                                      <div className="right">
                                        <span className="pointname">
                                          {" "}
                                          {selectedDroppingName
                                            ? selectedDroppingName.ArrivalTime
                                            : ""}{" "}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="dr-details" >
                                     

                                      <div className="right-content-br">
                                        <span>
                                          {selectedDroppingName?.AddressLine2
                                            .LandMark1 !== ""
                                            ? selectedDroppingName?.LandMark1
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedDroppingName?.LandMark2 !==
                                          ""
                                            ? selectedDroppingName?.LandMark2
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedDroppingName?.AddressLine1 !==
                                          ""
                                            ? selectedDroppingName?.AddressLine1
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedDroppingName?.AddressLine2 !==
                                          ""
                                            ? selectedDroppingName?.AddressLine2
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedDroppingName?.AddressLine3 !==
                                          ""
                                            ? selectedDroppingName?.AddressLine3
                                            : ""}
                                        </span>
                                      </div>

                                             

                                       <div className="left-content-br">
                                        
                                        
                                        <div className="content-bottom">
                                          <div className="icons-container">
                                            <ContactPhone mobileNumber={selectedDroppingName.ContactMobileNumber} />
                                            <a className="location-button" onClick={(e)=>{e.stopPropagation();}}  target="_blank" href={'/show-pickup-dropping?lat=15.350417344847436&lon=75.1391945019891'}>
                                              <CiLocationOn />
                                            </a>

                                            {/* <span className="location-button">
                                              <TbView360Number />
                                            </span> */}
                                          </div>

                                          {/* {selectedDroppingName?.ContactMobileNumber !==
                                          "" ? (
                                            <div className="mobile-number">
                                              <a
                                                href={
                                                  "tel:" +
                                                  selectedDroppingName?.ContactMobileNumber
                                                }
                                              >
                                                <CiPhone />{" "}
                                                <>
                                                  {
                                                    selectedDroppingName?.ContactMobileNumber
                                                  }{" "}
                                                </>{" "}
                                              </a>{" "}
                                              &nbsp;
                                            </div>
                                          ) : (
                                            ""
                                          )} */}
                                        </div>
                                      </div>


                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="payment-details-new">
                            <h3 className="headings-main">
                              Onward Journey Payment Details
                            </h3>
                            <div className="divider"></div>

                            <div className="payment-row">
                              <div className="perticulars"> Sub Total</div>
                              <div className="perticulars-amount">
                                {" "}
                                &#8377; {subtotalOnward.toFixed(2)}
                              </div>
                            </div>

                            <div
                              className="payment-row"
                              style={{
                                borderTop: "1px solid rgba(244, 203, 19, 0.22)",
                              }}
                            >
                              <div className="perticulars"> Discount </div>
                              <div className="perticulars-amount">
                                {" "}
                                - &#8377; {discountOnward.toFixed(2)}
                              </div>
                            </div>

                            <div
                              className="payment-row"
                              style={{
                                borderTop: "1px solid rgba(244, 203, 19, 0.22)",
                              }}
                            >
                              <div className="perticulars">
                                {" "}
                                GST ( {gstInpercentOnward} % ){" "}
                              </div>
                              <div className="perticulars-amount">
                                {" "}
                                &#8377; {totalGstOnward.toFixed(2)}
                              </div>
                            </div>
                            <div className="divider"></div>
                            <div className="payment-grand-row">
                              <div className="perticulars"> Grand Total </div>
                              <div className="perticulars-amount">
                                {" "}
                                &#8377; {grandTotalOnward.toFixed(2)}
                              </div>
                            </div>
                          </div>

                          {/* Return Journeyu Passanger Information */}

                          <div className="customer-info-table-content">
                            <div className="contact-details">
                              <h3 className="headings-main">
                                Return Contact Details
                              </h3>
                              <div className="divider"></div>
                              <div className="contact-details-card">
                                <div className="contact-details-form">
                                  <div style={{ width: "100%" }}>
                                    <Controller
                                      name="mobileReturn"
                                      control={control}
                                      rules={{
                                        required: "Mobile number is required",
                                        pattern: {
                                          value: /^[0-9]{10}$/,
                                          message:
                                            "Enter a valid 10-digit mobile number",
                                        },
                                      }}
                                      render={({ field }) => (
                                        <TextField
                                          {...field}
                                          // Capture the ref into our manual inputRefs map
                                          inputRef={(el) => {
                                            field.ref(el); // Still let RHF manage its own ref internally
                                            inputRefs.current.mobileReturn = el; // Manually track it for our scroll logic
                                          }}
                                          onBlur={(e) => {
                                            field.onBlur();
                                            const value = e.target.value;
                                            sendEventTobackend(
                                              "ContactMobileNoTouched",
                                              null,
                                              1,
                                            );
                                          }}
                                          placeholder="Mobile Number *"
                                          variant="outlined"
                                          size="small"
                                          fullWidth
                                          error={!!errors.mobileReturn}
                                          helperText={
                                            errors.mobileReturn?.message
                                          }
                                          inputProps={{
                                            maxLength: 10,
                                            autoComplete: "none",
                                          }}
                                          sx={{
                                            "& .MuiInputLabel-root": {
                                              fontSize: "13px",
                                              "&.Mui-focused": {
                                                color: "#2D3FA8",
                                              },
                                            },

                                            "& .MuiOutlinedInput-root": {
                                              maxHeight: "30px",

                                              "& .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },

                                              "&:hover .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "",
                                                },

                                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },
                                            },

                                            "& label.Mui-focused": {
                                              color: "#1F1F1F",
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </div>
                                  <div style={{ width: "100%" }}>
                                    <Controller
                                      name="emailReturn"
                                      control={control}
                                      rules={{
                                        required: "Email is required",
                                        pattern: {
                                          value:
                                            /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i,
                                          message:
                                            "Enter a valid email address",
                                        },
                                      }}
                                      render={({ field }) => (
                                        <TextField
                                          {...field}
                                          inputRef={(el) => {
                                            field.ref(el); // Still let RHF manage its own ref internally
                                            inputRefs.current.emailReturn = el; // Manually track it for our scroll logic
                                          }}
                                          onBlur={(e) => {
                                            field.onBlur();
                                            const value = e.target.value;
                                            sendEventTobackend(
                                              "ContactEmailTouched",
                                              null,
                                              1,
                                            );
                                          }}
                                          placeholder="E-mail *"
                                          variant="outlined"
                                          size="small"
                                          fullWidth
                                          error={!!errors.emailReturn}
                                          helperText={
                                            errors.emailReturn?.message
                                          }
                                          inputProps={{ autoComplete: "none" }}
                                          sx={{
                                            "& .MuiInputLabel-root": {
                                              fontSize: "13px",
                                              "&.Mui-focused": {
                                                color: "#2D3FA8",
                                              },
                                            },

                                            "& .MuiOutlinedInput-root": {
                                              maxHeight: "30px",

                                              "& .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },

                                              "&:hover .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "",
                                                },

                                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },
                                            },

                                            "& label.Mui-focused": {
                                              color: "#1F1F1F",
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </div>

                                  <div style={{ width: "100%" }}>
                                                                  <Controller
                                                                    name="GSTNumberReturn"
                                                                    control={control}
                                                                    rules={{
                                                                      pattern: {
                                                                       value: /^[a-zA-Z0-9]{15}$/, 
                                                                      //  exact gst pattern match
                                                                      //  /^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1}$/
                                                                        message:
                                                                          "Enter a valid 15-digit GST number",
                                                                      },
                                                                    }}
                                                                    render={({ field }) => (
                                                                      <TextField
                                                                        {...field}
                                                                        // Capture the ref into our manual inputRefs map
                                                                        inputRef={(el) => {
                                                                          field.ref(el); // Still let RHF manage its own ref internally
                                                                          inputRefs.current.GSTNumberReturn = el; // Manually track it for our scroll logic
                                                                        }}
                                                                        onBlur={(e)=>{
                                                                          field.onBlur();
                                                                          const value = e.target.value;
                                                                          sendEventTobackend("ContactGSTNumberTouched",null,1) 
                                                                        }}
                                                                                                              placeholder="GST Number"
                                                                        variant="outlined"
                                                                        size="small"
                                                                        fullWidth
                                                                        error={!!errors.GSTNumberReturn}
                                                                        helperText={errors.GSTNumberReturn?.message}
                                                                        inputProps={{
                                                                          maxLength: 15 ,
                                                                          autoComplete: "none",
                                                                        }}
                                                                        sx={{
                                                                          "& .MuiInputLabel-root": {
                                                                            fontSize: "13px",
                                                                            "&.Mui-focused": {
                                                                              color: "#2D3FA8",
                                                                            },
                                                                          },
                                  
                                                                          "& .MuiOutlinedInput-root": {
                                                                            maxHeight: "30px",
                                  
                                                                            "& .MuiOutlinedInput-notchedOutline":
                                                                              {
                                                                                borderColor: "#2D3FA8",
                                                                                borderWidth: "1px",
                                                                              },
                                  
                                                                            "&:hover .MuiOutlinedInput-notchedOutline":
                                                                              {
                                                                                borderColor: "",
                                                                              },
                                  
                                                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                                              {
                                                                                borderColor: "#2D3FA8",
                                                                                borderWidth: "1px",
                                                                              },
                                                                          },
                                  
                                                                          "& label.Mui-focused": {
                                                                            color: "#1F1F1F",
                                                                          },
                                                                        }}
                                                                      />
                                                                    )}
                                                                  />
                                   </div>

                                </div>
                                <small
                                  style={{
                                    color: "#2D3FA8",
                                    paddingLeft: "0px",
                                  }}
                                >
                                  Journey & Ticket Details will be sent these
                                  details!
                                </small>
                              </div>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginBottom: "8px",
                              }}
                            >
                              {getValues("mobileOnward") !== "" &&
                                getValues("mobileOnward") !== null && (
                                  <button
                                    type="button"
                                    style={{
                                      color: "#2D3FA8",
                                      background: "none",
                                      border: "none",
                                      cursor: "pointer",
                                      fontSize: "13px",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => {
                                      setValue(
                                        "mobileReturn",
                                        getValues("mobileOnward"),
                                      );
                                      setValue(
                                        "emailReturn",
                                        getValues("emailOnward"),
                                      );
                                    }}
                                  >
                                    Copy from Onward Journey
                                  </button>
                                )}
                            </div>
                          </div>

                          <div className="passenger-details">
                            <h3 className="headings-main">
                              Return Journey Passanger Details
                            </h3>
                            <div className="divider"></div>

                            <div className="table-header">
                              <div className="column-title"> Sl. No </div>
                              <div className="column-title"> Seat </div>
                              <div className="column-title"> Name </div>
                              <div className="column-title"> Age </div>
                              <div className="column-title"> Gender </div>
                              <div className="column-title price"> Price </div>
                            </div>

                            <div className="table-body">
                              {/* map over updatedSeats to render one row per passenger and wire to form passengers[index] */}
                              {updatedSeatsReturn?.map((item, index) => (
                                <div
                                  className="filed-row"
                                  key={item.SeatID ?? index}
                                >
                                  <div className="field"> {index + 1} </div>
                                  <div className="field">
                                    {" "}
                                    {item.SeatNumber}{" "}
                                  </div>

                                  {/* PASSENGER NAME */}
                                  <div className="field">
                                    <Controller
                                      name={`passengersReturn.${index}.passangerName`}
                                      control={control}
                                      rules={{
                                        required: "Name is required",
                                        pattern: {
                                          value: /^[a-zA-Z ]*$/,
                                          message: "Enter valid Name",
                                        },
                                        minLength: {
                                          value: 2,
                                          message: "Enter a valid name",
                                        },
                                      }}
                                      render={({ field }) => (
                                        <TextField
                                          {...field}
                                          inputRef={(el) => {
                                            field.ref(el); // Still let RHF manage its own ref internally
                                            inputRefs.current.passangerName =
                                              el; // Manually track it for our scroll logic
                                          }}
                                          placeholder="Passenger Name *"
                                          variant="outlined"
                                          size="small"
                                          inputProps={{ autoComplete: "none" }}
                                          onChange={(e) => {
                                            field.onChange(e); // update react-hook-form
                                            const newSeats = [...updatedSeats];
                                            if (newSeats[index]) {
                                              newSeats[index].passangerName =
                                                e.target.value;
                                              setUpdatedSeats(newSeats); // sync with updatedSeats
                                            }
                                          }}
                                          onBlur={(e) => {
                                            field.onBlur();
                                            const value = e.target.value;
                                            sendEventTobackend(
                                              "PassengerNameTouched",
                                              null,
                                              1,
                                            );
                                          }}
                                          error={
                                            !!(
                                              errors.passengersReturn &&
                                              errors.passengersReturn[index]
                                                ?.passangerName
                                            )
                                          }
                                          helperText={
                                            errors.passengersReturn &&
                                            errors.passengersReturn[index]
                                              ?.passangerName?.message
                                          }
                                          fullWidth
                                          sx={{
                                            "& .MuiInputLabel-root": {
                                              fontSize: "13px",
                                              "&.Mui-focused": {
                                                color: "#2D3FA8",
                                              },
                                            },

                                            "& .MuiOutlinedInput-root": {
                                              maxHeight: "30px",

                                              "& .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },

                                              "&:hover .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "",
                                                },

                                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },
                                            },

                                            "& label.Mui-focused": {
                                              color: "#1F1F1F",
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </div>

                                  {/* PASSENGER AGE */}
                                  <div className="field">
                                    <Controller
                                      name={`passengersReturn.${index}.age`}
                                      control={control}
                                      rules={{
                                        required: "Age is required",
                                        pattern: {
                                          value: /^[0-9]{1,3}$/,
                                          message: "Enter valid age",
                                        },
                                        validate: (v) =>
                                          (Number(v) > 0 && Number(v) < 130) ||
                                          "Enter valid age",
                                      }}
                                      render={({ field }) => (
                                        <TextField
                                          {...field}
                                          inputRef={(el) => {
                                            field.ref(el); // Still let RHF manage its own ref internally
                                            inputRefs.current.age = el; // Manually track it for our scroll logic
                                          }}
                                          placeholder="Age *"
                                          variant="outlined"
                                          size="small"
                                          error={
                                            !!(
                                              errors.passengersReturn &&
                                              errors.passengersReturn[index]
                                                ?.age
                                            )
                                          }
                                          helperText={
                                            errors.passengersReturn &&
                                            errors.passengersReturn[index]?.age
                                              ?.message
                                          }
                                          inputProps={{
                                            inputMode: "numeric",
                                            pattern: "[0-9]*",
                                            maxLength: 3,
                                            autoComplete: "none",
                                          }}
                                          onChange={(e) => {
                                            field.onChange(e); // update react-hook-form
                                            const newSeats = [
                                              ...updatedSeatsReturn,
                                            ];
                                            if (newSeats[index]) {
                                              newSeats[index].age =
                                                e.target.value;
                                              setUpdatedSeatsReturn(newSeats); // sync with updatedSeats
                                            }
                                          }}
                                          onBlur={(e) => {
                                            field.onBlur();
                                            const value = e.target.value;
                                            sendEventTobackend(
                                              "PassengerAgeTouched",
                                              null,
                                              1,
                                            );
                                          }}
                                          fullWidth
                                          sx={{
                                            "& .MuiInputLabel-root": {
                                              fontSize: "13px",
                                              "&.Mui-focused": {
                                                color: "#2D3FA8",
                                              },
                                            },

                                            "& .MuiOutlinedInput-root": {
                                              maxHeight: "30px",

                                              "& .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },

                                              "&:hover .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "",
                                                },

                                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor: "#2D3FA8",
                                                  borderWidth: "1px",
                                                },
                                            },

                                            "& label.Mui-focused": {
                                              color: "#1F1F1F",
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </div>

                                  {/* GENDER (keeps your current UI + handlers) */}
                                  <div className="gender">
                                    <div
                                      className="gender-switch-container"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          color: "#3D18B5",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          handleMaleIconClick(item.SeatNumber)
                                        }
                                      >
                                        <img
                                          src="/images/MaleTransparent_1.png"
                                          style={{
                                            width: "34px",
                                            height: "34px",
                                            borderRadius: "4px",
                                          }}
                                        />
                                      </span>

                                      <FormControlLabel
                                        control={
                                          <Switch
                                            checked={item.gender}
                                            onChange={() =>
                                              handleGenderChange(
                                                item.SeatNumber,
                                              )
                                            }
                                            sx={{
                                              "& .MuiSwitch-thumb": {
                                                backgroundColor: item.gender
                                                  ? "#ff1493"
                                                  : "#2D3FA8",
                                              },
                                              "& .MuiSwitch-track": {
                                                backgroundColor: "#F4CC13",
                                                opacity: 0.4,
                                              },
                                            }}
                                          />
                                        }
                                      />

                                      <span
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          handleFeMaleIconClick(item.SeatNumber)
                                        }
                                      >
                                        <img
                                          src="/images/femaleTransparent1.png"
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "4px",
                                          }}
                                        />
                                      </span>
                                    </div>
                                  </div>

                                  <div className="field price">
                                    &#8377; {item.FARE}
                                  </div>
                                </div>
                              ))}
                            </div>

                            {/* Add this just before Return Journey table-body */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                type="button"
                                style={{
                                  color: "#2D3FA8",
                                  background: "none",
                                  border: "none",
                                  cursor: "pointer",
                                  fontSize: "13px",
                                  textDecoration: "underline",
                                }}
                                onClick={() => {
                                  updatedSeats.forEach((seat, index) => {
                                    setValue(
                                      `passengersReturn.${index}.passangerName`,
                                      seat.passangerName || "",
                                    );
                                    setValue(
                                      `passengersReturn.${index}.age`,
                                      seat.age || "",
                                    );
                                    // Sync to state too
                                    const newSeats = [...updatedSeatsReturn];
                                    if (newSeats[index]) {
                                      newSeats[index].passangerName =
                                        seat.passangerName || "";
                                      newSeats[index].age = seat.age || "";
                                    }
                                    setUpdatedSeatsReturn(newSeats);
                                  });
                                }}
                              >
                                Copy from Onward Journey
                              </button>
                            </div>
                          </div>

                          <div className="br-dr-container">
                            <div className="passenger-card-container-small">
                              <div className="card-top-button-br-dr">
                                Boarding Point
                              </div>
                              <div className="passenger-card-small">
                                <div className="boarding-dropping-info">
                                  <div>
                                    <div className="points">
                                      <div className="left">
                                        <span className="pointname">
                                          {" "}
                                          {selectedBoardingNameReturn
                                            ? selectedBoardingNameReturn.PointName
                                            : ""}{" "}
                                        </span>
                                      </div>
                                      <div className="right">
                                        <span className="pointname">
                                          {" "}
                                          {selectedBoardingNameReturn
                                            ? selectedBoardingNameReturn.DepartureTime
                                            : ""}{" "}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="dr-details" >
                                      

                                      <div className="right-content-br">
                                        <span>
                                          {selectedBoardingNameReturn
                                            ?.AddressLine2.LandMark1 !== ""
                                            ? selectedBoardingNameReturn?.LandMark1
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedBoardingNameReturn?.LandMark2 !==
                                          ""
                                            ? selectedBoardingNameReturn?.LandMark2
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedBoardingNameReturn?.AddressLine1 !==
                                          ""
                                            ? selectedBoardingNameReturn?.AddressLine1
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedBoardingNameReturn?.AddressLine2 !==
                                          ""
                                            ? selectedBoardingNameReturn?.AddressLine2
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedBoardingNameReturn?.AddressLine3 !==
                                          ""
                                            ? selectedBoardingNameReturn?.AddressLine3
                                            : ""}
                                        </span>
                                      </div>

                                      <div className="left-content-br">
                                        <div className="content-bottom">
                                          <ContactPhone mobileNumber={selectedBoardingNameReturn?.ContactMobileNumber} />
                                          <div className="icons-container">
                                            <a className="location-button" onClick={(e)=>{e.stopPropagation();}}  target="_blank" href={'/show-pickup-dropping?lat=15.350417344847436&lon=75.1391945019891'}>
                                              <CiLocationOn />
                                            </a>

                                            {/* <span className="location-button">
                                              <TbView360Number />
                                            </span> */}
                                          </div>

                                          {/* {selectedBoardingNameReturn?.ContactMobileNumber !=
                                          "" ? (
                                            <div className="mobile-number">
                                              <a
                                                href={
                                                  "tel:" +
                                                  selectedBoardingNameReturn?.ContactMobileNumber
                                                }
                                              >
                                                <CiPhone />{" "}
                                                <>
                                                  {
                                                    selectedBoardingNameReturn?.ContactMobileNumber
                                                  }{" "}
                                                </>{" "}
                                              </a>{" "}
                                              &nbsp;
                                            </div>
                                          ) : (
                                            ""
                                          )} */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="passenger-card-container-small">
                              <div className="card-top-button-br-dr">
                                Dropping Point
                              </div>
                              <div className="passenger-card-small">
                                <div className="boarding-dropping-info">
                                  <div>
                                    <div className="points">
                                      <div className="left">
                                        <span className="pointname">
                                          {" "}
                                          {selectedDroppingNameReturn
                                            ? selectedDroppingNameReturn.PointName
                                            : ""}{" "}
                                        </span>
                                      </div>
                                      <div className="right">
                                        <span className="pointname">
                                          {" "}
                                          {selectedDroppingNameReturn
                                            ? selectedDroppingNameReturn.ArrivalTime
                                            : ""}{" "}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="dr-details" >
                                     

                                      <div className="right-content-br">
                                        <span>
                                          {selectedDroppingNameReturn
                                            ?.AddressLine2.LandMark1 !== ""
                                            ? selectedDroppingNameReturn?.LandMark1
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedDroppingNameReturn?.LandMark2 !==
                                          ""
                                            ? selectedDroppingNameReturn?.LandMark2
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedDroppingNameReturn?.AddressLine1 !==
                                          ""
                                            ? selectedDroppingNameReturn?.AddressLine1
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedDroppingNameReturn?.AddressLine2 !==
                                          ""
                                            ? selectedDroppingNameReturn?.AddressLine2
                                            : ""}
                                        </span>
                                        <span>
                                          {selectedDroppingNameReturn?.AddressLine3 !==
                                          ""
                                            ? selectedDroppingNameReturn?.AddressLine3
                                            : ""}
                                        </span>
                                      </div>


                                       <div className="left-content-br">
                                        <div className="content-bottom">
                                        <ContactPhone mobileNumber={selectedBoardingNameReturn?.ContactMobileNumber} />
                                          <div className="icons-container">
                                            <span className="location-button">
                                              <CiLocationOn />
                                            </span>

                                            {/* <span className="location-button">
                                              <TbView360Number />
                                            </span> */}
                                          </div>



 
                                          {/* {selectedDroppingNameReturn?.ContactMobileNumber !==
                                          "" ? (
                                            <div className="mobile-number">
                                              <a
                                                href={
                                                  "tel:" +
                                                  selectedDroppingNameReturn?.ContactMobileNumber
                                                }
                                              >
                                                <CiPhone />{" "}
                                                <>
                                                  {
                                                    selectedDroppingNameReturn?.ContactMobileNumber
                                                  }{" "}
                                                </>{" "}
                                              </a>{" "}
                                              &nbsp;
                                            </div>
                                          ) : (
                                            ""
                                          )} */}
                                        </div>
                                      </div>


                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="payment-details-new">
                            <h3 className="headings-main">
                              Return Journey Payment Details
                            </h3>
                            <div className="divider"></div>

                            <div className="payment-row">
                              <div className="perticulars"> Sub Total</div>
                              <div className="perticulars-amount">
                                {" "}
                                &#8377; {subtotalReturn.toFixed(2)}
                              </div>
                            </div>

                            <div
                              className="payment-row"
                              style={{
                                borderTop: "1px solid rgba(244, 203, 19, 0.22)",
                              }}
                            >
                              <div className="perticulars"> Discount </div>
                              <div className="perticulars-amount">
                                {" "}
                                - &#8377; {discountReturn.toFixed(2)}
                              </div>
                            </div>

                            <div
                              className="payment-row"
                              style={{
                                borderTop: "1px solid rgba(244, 203, 19, 0.22)",
                              }}
                            >
                              <div className="perticulars">
                                {" "}
                                GST ( {gstInpercentReturn} % ){" "}
                              </div>
                              <div className="perticulars-amount">
                                {" "}
                                &#8377; {totalGstReturn.toFixed(2)}
                              </div>
                            </div>
                            <div className="divider"></div>
                            <div className="payment-grand-row">
                              <div className="perticulars"> Grand Total </div>
                              <div className="perticulars-amount">
                                {" "}
                                &#8377; {grandTotalReturn.toFixed(2)}
                              </div>
                            </div>
                        
                          
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="unselected">
                        <span>
                          Please select seats, boarding and dropping points for
                          both onward and return journey to proceed with
                          passenger details.
                        </span>

                        <span
                          onClick={() => {
                            setTabMainValue(0);
                          }}
                        >
                          Click here to go back to seat selection Onward
                          Journey.
                        </span>

                        <span
                          onClick={() => {
                            setTabMainValue(1);
                          }}
                        >
                          Click here to go back to seat selection Return
                          Journey.
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </>
            </CustomTabPanel>
          </DialogContent>

          <DialogActions
            sx={{
              borderTop: "2px solid #2D3FA8;",
              height: "80px",
              maxHeight: "80px",
            }}
          >
            <div className="dialog-footer-roundtrip">
              {tabMainValue != 2 && (
                <>
                  <div className="onward-bottom-section">
                    <div className="onward-container">
                      <h6 className="jourey-title"> Onward Journey </h6>
                      <div className="onward-bottom">
                        {updatedSeats?.length > 0 ? (
                          <div className="show-selected-seats">
                            {
                              <>
                                <div className="selected-seat-list">
                                  <span>Selected Seats </span>
                                  <div className="seat-selected-chip-container">
                                    {updatedSeats?.map((item) => (
                                      <div
                                        className="selected-seat-chip"
                                        style={
                                          item.gender
                                            ? { backgroundColor: "#FFC0CB" }
                                            : {
                                                backgroundColor: "#2D3FA8",
                                                color: "#fff",
                                              }
                                        }
                                      >
                                        {" "}
                                        {item.SeatNumber}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </>
                            }
                          </div>
                        ) : (
                          <>
                            <div className="show-selected-seats">
                              <div className="selected-seat-list">
                                <span>Selected Seats </span>
                                <div className="seat-selected-chip-container">
                                  None
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        <div className="dialog-bottom-group">
                          {selectedBoarding?.length > 0 &&
                          selectedDropping?.length > 0 ? (
                            <>
                              {selectedSeats.length > 0 && (
                                <>
                                  <div className="grand-total-footer">
                                    <span className="gt-label">
                                      Grand Total
                                    </span>
                                    <span className="gt-amount">
                                      {" "}
                                      <del>
                                        &#8377;{" "}
                                        {(
                                          grandwithoutDiscOnward +
                                          (grandwithoutDiscOnward * 5) / 100
                                        ).toFixed(2)}
                                      </del>
                                    </span>{" "}
                                    &nbsp;
                                    <span className="gt-amount">
                                      {" "}
                                      &#8377; {grandTotalOnward}{" "}
                                    </span>






                                       <Tooltip
                                                title={tooltipContentOnward}
                                                arrow
                                                placement="top"
                                                slotProps={{
                                                  popper: {
                                                    modifiers: [
                                                      {
                                                        name: 'offset',
                                                        options: {
                                                          offset: [0, 10],
                                                        },
                                                      },
                                                    ],
                                                  },
                                                  tooltip: {
                                                    sx: {
                                                      bgcolor: '#ffffff',
                                                      color: '#333',
                                                      boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                                      fontSize: '12px',
                                                      border: '1px solid #e0e0e0',
                                                      borderRadius: '4px',
                                                      width:'100%',
                                                      minWidth:"500px",
                                                      p: 0,
                                                    },
                                                  },
                                                }}
                                              >
                                                <MdInfo
                                                  style={{
                                                      fontSize: '18px',
                                                      cursor: 'pointer',
                                                      color: '#2D3FA8',
                                                    }}
                                                    onMouseEnter={(e) => e.target.style.color = '#F0C800'}
                                                    onMouseLeave={(e) => e.target.style.color = '#2D3FA8'}

                                                />
                                              </Tooltip>





















                                  </div>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <button
                                className="continue-button"
                                onClick={() => setTabValue(1)}
                                disabled={selectedSeats?.length <= 0}
                              >
                                <span>
                                  Continue To Boarding/Dropping Points
                                </span>
                                <span>
                                  {" "}
                                  <MdArrowForward />{" "}
                                </span>
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    {selectedBoarding?.length > 0 &&
                      selectedDropping?.length > 0 &&
                      globalData.returnSelectedSeats == null && (
                        <>
                          <button
                            className="continue-button"
                            onClick={() => {
                              handleTabChangeInDialog("2");
                            }}
                            disabled={selectedSeats?.length <= 0}
                          >
                            <span>Continue To Return Journey</span>
                            <span>
                              {" "}
                              <MdArrowForward />{" "}
                            </span>
                          </button>
                        </>
                      )}

                    {selectedSeats?.length > 0 &&
                      selectedBoarding?.length > 0 &&
                      selectedDropping?.length > 0 &&
                      selectedSeatsReturn?.length > 0 &&
                      selectedBoardingReturn?.length > 0 &&
                      selectedDroppingReturn?.length > 0 && (
                        <>
                          <button
                            className="continue-button"
                            onClick={() => {
                              setTabMainValue(2);
                            }}
                          >
                            <span>Continue To Passenger Information </span>
                            <span>
                              {" "}
                              <MdArrowForward />{" "}
                            </span>
                          </button>
                        </>
                      )}
                  </div>

                  <div className="return-bottom-section">
                    <div className="return-container" >
                      <h6 className="jourey-title" style={{textAlign:'right'}}> Return Journey </h6>
                      <div className="return-bottom" style={{flexDirection:"row-reverse"}}>
                        {updatedSeatsReturn?.length > 0 ? (
                          <div className="show-selected-seats">
                            {
                              <>
                                <div className="selected-seat-list">
                                  <span>Selected Seats </span>
                                  <div className="seat-selected-chip-container">
                                    {updatedSeatsReturn?.map((item) => (
                                      <div
                                        className="selected-seat-chip"
                                        style={
                                          item.gender
                                            ? { backgroundColor: "#FFC0CB" }
                                            : {
                                                backgroundColor: "#2D3FA8",
                                                color: "#fff",
                                              }
                                        }
                                      >
                                        {" "}
                                        {item.SeatNumber}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </>
                            }
                          </div>
                        ) : (
                          <>
                            <div className="show-selected-seats">
                              <div className="selected-seat-list">
                                <span>Selected Seats </span>
                                <div className="seat-selected-chip-container">
                                  None
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        <div className="dialog-bottom-group">
                          {selectedBoardingReturn?.length > 0 &&
                          selectedDroppingReturn?.length > 0 ? (
                            <>
                              {selectedSeatsReturn.length > 0 && (
                                <div className="grand-total-footer">
                                   <Tooltip
                                      title={tooltipContentReturn}
                                      arrow
                                      placement="top"
                                      slotProps={{
                                        popper: {
                                          modifiers: [
                                            {
                                              name: 'offset',
                                              options: {
                                                offset: [0, 10],
                                              },
                                            },
                                          ],
                                        },
                                        tooltip: {
                                          sx: {
                                            bgcolor: '#ffffff',
                                            color: '#333',
                                            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                            fontSize: '12px',
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '4px',
                                            width:'100%',
                                            minWidth:"500px",
                                            p: 0,
                                          },
                                        },
                                      }}
                                    >
                                      <MdInfo
                                        style={{
                                            fontSize: '18px',
                                            cursor: 'pointer',
                                            color: '#2D3FA8',
                                          }}
                                          onMouseEnter={(e) => e.target.style.color = '#F0C800'}
                                          onMouseLeave={(e) => e.target.style.color = '#2D3FA8'}

                                      />
                                    </Tooltip>     

                                  <span className="gt-label">Grand Total</span>
                                  <span className="gt-amount">
                                    {" "}
                                    <del>
                                      &#8377;{" "}
                                      {(
                                        grandwithoutDiscReturn +
                                        (grandwithoutDiscReturn * 5) / 100
                                      ).toFixed(2)}
                                    </del>
                                  </span>{" "}
                                  &nbsp;
                                  <span className="gt-amount">
                                    {" "}
                                    &#8377; {grandTotalReturn.toFixed(2)}{" "}
                                  </span>



                                   









                                </div>
                              )}
                            </>
                          ) : (
                            <>
                              <button
                                className="continue-button"
                                onClick={() => setReturnTabValue(1)}
                                disabled={selectedSeatsReturn?.length <= 0}
                              >
                                <span>
                                  Continue To Boarding/Dropping Points
                                </span>
                                <span>
                                  {" "}
                                  <MdArrowForward />{" "}
                                </span>
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {tabMainValue === 2 && (
                <>
                  <div className="dialog-bottom-group">
                    <div className="grand-total-footer" >
                      <span className="gt-label">Round Trip Grand Total</span>
                      <span className="gt-amount">
                        {" "}
                        <del>
                          &#8377;{" "}
                          {(
                            grandwithoutDiscOnward +
                            grandwithoutDiscReturn +
                            ((grandwithoutDiscOnward + grandwithoutDiscReturn) *
                              5) /
                              100
                          ).toFixed(2)}
                        </del>
                      </span>{" "}
                      &nbsp;
                      <span className="gt-amount">
                        {" "}
                        &#8377;{" "}
                        {(grandTotalOnward + grandTotalReturn).toFixed(2)}{" "}
                      </span>




                      <Tooltip
                        title={tooltipContentBoth}
                        arrow
                        placement="top"
                        slotProps={{
                          popper: {
                            modifiers: [
                              {
                                name: 'offset',
                                options: {
                                  offset: [0, 10],
                                },
                              },
                            ],
                          },
                          tooltip: {
                            sx: {
                              bgcolor: '#ffffff',
                              color: '#333',
                              boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                              fontSize: '12px',
                              border: '1px solid #e0e0e0',
                              borderRadius: '4px',
                              width:'100%',
                              minWidth:"500px",
                              p: 0,
                            },
                          },
                        }}
                      >
                        <MdInfo
                          style={{
                              fontSize: '18px',
                              cursor: 'pointer',
                              color: '#2D3FA8',
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#F0C800'}
                            onMouseLeave={(e) => e.target.style.color = '#2D3FA8'}

                        />
                      </Tooltip>






                       
                    </div>
                  </div>

                  <div>
                    <div className="dialog-bottom-group">
                      <div className="dialog-bottom-group">
                        <button
                          className="back-button"
                          onClick={() => setTabMainValue(1)}
                        >
                          {" "}
                          <span>
                            <MdArrowBack />
                          </span>{" "}
                          <span>Back</span>{" "}
                        </button>
                        <button
                          className={`continue-button ${isLoading ? "loading" : ""}`}
                          onClick={handleSubmit(onSubmit, onInvalid)}
                          disabled={isLoading}
                        >
                          <span class="button-spinner"></span>
                          <span> Book Now </span>
                          <span>
                            <MdArrowForward />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </DialogActions>
        </Dialog>

        <form
          ref={formref}
          action={"/" + paths.BookSeatsTempEndPoint}
          method="POST"
          style={{ display: "none" }}
        >
          <input value={JSON.stringify(frompayload)} name="form_payload" />
        </form>
      </Fragment>

      <ComponentLevelLoader isLoading={isLoading} />
    </>
  );
};

export default JourneyRoundTripDailog;
